/** Минимальный i18n без библиотеки. RU — основной, EN/ES заложены сразу:
 *  дописать словарь дешевле, чем вынимать строки из вёрстки потом.
 *  EN и ES типизированы по RU — забытый ключ ломает сборку, а не прод. */


export type Lang = 'ru' | 'en' | 'es'

const ru = {
  feed: 'Игры',
  create: 'Создать',
  profile: 'Профиль',
  myLevelOnly: 'Только мой уровень',
  homeYou: 'Вы?',
  homeFree: 'Свободно',
  homeRoster: 'Состав',
  courtBookedShort: 'корт забронирован',
  homeSeats: (n: number, max: number): string => `${n} из ${max} мест`,
  homeCity: 'Город',
  homeAllTowns: 'Вся Марина',
  homeYourLevel: 'ваш уровень',
  homeWeek: 'Неделя',
  homeHaveGame: 'есть игра',
  homeNext: 'Ваша ближайшая игра',
  homeAllMine: (n: number): string => `Все мои · ${n}`,
  homeNoNext: 'Вы пока никуда не записаны',
  homeInvites: (name: string): string => `${name} зовёт в игру`,
  homeTournaments: 'Турниры',
  homeMine: 'Мои игры',
  homeOpen: 'Открытые игры',
  homeSegLevel: 'Мой уровень',
  homeSegAll: 'Все',
  homeSegMine: 'Мои',
  homeNothing: 'Подходящих игр пока нет',
  dealsTitle: 'Скидки на падел',
  dealsAd: 'Партнёрские ссылки',
  adminDeals: 'Скидки',
  adminDealUrl: 'Ссылка на товар',
  adminDealFill: 'Заполнить по ссылке',
  adminDealTitle: 'Название',
  adminDealShop: 'Магазин',
  adminDealImage: 'Картинка (ссылка)',
  adminDealPrice: 'Цена, €',
  adminDealOld: 'Старая цена, €',
  adminDealCategory: 'Категория',
  adminDealExpires: 'Действует до',
  adminDealActive: 'Показывать в ленте',
  adminDealNew: '+ Новая скидка',
  adminDealDelete: 'Удалить',
  adminDealDeleteConfirm: 'Удалить скидку вместе со статистикой переходов?',
  adminDealClicks: (clicks: number, people: number): string => {
    const m10 = clicks % 10
    const m100 = clicks % 100
    const word = m10 === 1 && m100 !== 11 ? 'переход' : m10 >= 2 && m10 <= 4 && (m100 < 12 || m100 > 14) ? 'перехода' : 'переходов'
    return `${clicks} ${word} · ${people} чел.`
  },
  adminDealHint: 'Полоса видна в ленте, пока есть хоть одна действующая скидка. Ссылки помечены как партнёрские.',
  dealCategories: { palas: 'Ракетки', zapatillas: 'Кроссовки', pelotas: 'Мячи', ropa: 'Одежда', accesorios: 'Аксессуары' } as Record<string, string>,
  coachesTitle: 'Тренеры',
  coachesAll: 'Все',
  coachesHome: 'Тренеры и тренировки',
  trainingBadge: '🎓 Тренировка',
  trainingGroup: 'Групповая тренировка',
  coachLabel: 'Тренер',
  coachFrom: (price: number): string => `от ${price} €`,
  fmtName: { single: 'Индивидуальная', split: 'Сплит (вдвоём)', group: 'В группе' } as Record<string, string>,
  fmtUnit: { single: 'за час', split: 'за час на двоих', group: 'с человека' } as Record<string, string>,
  coachLevels: (lo: string, hi: string): string => `Ученики уровня ${lo}–${hi}`,
  coachYears: (n: number): string => {
    const m10 = n % 10
    const m100 = n % 100
    const word = m10 === 1 && m100 !== 11 ? 'год' : m10 >= 2 && m10 <= 4 && (m100 < 12 || m100 > 14) ? 'года' : 'лет'
    return `${n} ${word} опыта`
  },
  coachLanguages: 'Языки',
  coachClubs: 'Где тренирует',
  coachUpcoming: 'Ближайшие групповые тренировки',
  coachRequestTitle: 'Записаться на тренировку',
  coachRequestFormat: 'Формат',
  coachRequestWhen: 'Когда удобно',
  whenChips: ['Утро', 'День', 'Вечер', 'Будни', 'Выходные'],
  coachRequestMessage: 'Комментарий для тренера',
  coachRequestPlaceholder: 'Например: играю полгода, хочу поставить бандеху',
  coachRequestConsent:
    'Тренер увидит ваше имя, уровень и комментарий, а приняв заявку — ваш Telegram. Цену, время и оплату вы согласуете с тренером напрямую.',
  coachRequestSend: 'Отправить заявку',
  coachRequestSent: 'Заявка отправлена — тренер ответит в Telegram',
  coachReq: { new: 'Заявка отправлена · ждём ответа', accepted: 'Тренер принял заявку и напишет вам', declined: 'Тренер не смог взять заявку' } as Record<string, string>,
  coachWrite: 'Написать тренеру',
  coachRequestAgain: 'Новая заявка',
  coachesEmpty: 'Здесь пока нет тренеров',
  coachesAnyLang: 'Любой язык',
  coachCta: '🎓 Я тренер',
  coachCtaHint: 'Разместите профиль тренера — игроки отправят заявки на тренировки прямо вам в Telegram.',
  coachNeedTelegram: 'Заявки приходят в Telegram — сначала подключите его в профиле.',
  coachMyProfile: 'Профиль тренера',
  coachEdit: 'Редактировать анкету',
  coachStatus: { pending: 'На проверке', approved: 'Опубликован', rejected: 'Не одобрен — поправьте и отправьте снова', paused: 'Скрыт администратором' } as Record<string, string>,
  coachInbox: (n: number): string => (n ? `Заявки · новых ${n}` : 'Заявки'),
  coachInboxEmpty: 'Заявок пока нет. Как только игрок отправит заявку, она придёт сюда и в Telegram.',
  coachAccept: 'Принять',
  coachDecline: 'Не смогу',
  coachReqStatus: { new: 'Новая', accepted: 'Принята', declined: 'Отклонена' } as Record<string, string>,
  coachContact: 'Написать игроку',
  coachContactViaBot: 'Контакт игрока бот прислал вам в Telegram',
  coachNewTraining: '+ Групповая тренировка',
  coachName: 'Имя на карточке',
  coachBio: 'О себе',
  coachBioHint: 'Опыт, с кем работаете, чем поможете. Минимум 30 символов.',
  coachCert: 'Сертификат или школа',
  coachYearsLabel: 'Лет опыта',
  coachLevelsLabel: 'С каким уровнем работаете',
  coachFormatsLabel: 'Форматы и цены, €',
  coachClubsLabel: 'Клубы, где тренируете',
  coachLangsLabel: 'Языки',
  coachSubmit: 'Отправить на проверку',
  coachSubmitted: 'Профиль отправлен на проверку — ответ придёт в Telegram',
  coachDelete: 'Удалить профиль тренера',
  coachDeleteConfirm: 'Удалить профиль тренера? Игроки больше не увидят вас в разделе.',
  coachFillAll: 'Заполните имя, описание (от 30 символов), языки, клубы и хотя бы один формат',
  adminCoaches: 'Тренеры',
  adminApprove: 'Одобрить',
  adminReject: 'Отклонить',
  adminPause: 'Скрыть',
  adminRestore: 'Вернуть',
  adminCoachStats: (req: number, acc: number): string => `заявок ${req} · принято ${acc}`,
  kindTraining: '🎓 Тренировка',
  kindHintTraining: 'Вы ведёте, ученики записываются как в игру. Места тренера в составе нет, счёт не вносится, уровень не меняется.',
  trainingFor: 'Для кого',
  levelPresets: ['Начинающие', 'Средний', 'Продвинутые', 'Любой уровень'],
  createTraining: 'Создать тренировку',
  students: 'Учеников',
  chatTraining: 'Чат тренировки',
  coachAbout: 'О тренере',
  removePlayer: 'Снять с игры',
  removePlayerConfirm: (name: string): string =>
    `Снять ${name} с игры? Игрок получит сообщение. Вернуть его сможете только вы — через «Пригласить игроков».`,
  removedNote: 'Капитан снял вас с этой игры. Вернуться можно только по его приглашению.',
  chatReport: 'Пожаловаться',
  chatReportConfirm: 'Пожаловаться на сообщение? Вы его больше не увидите, а мы разберёмся в течение суток.',
  chatReported: 'Жалоба отправлена. Спасибо.',
  chatBlock: 'Скрыть автора',
  chatBlockConfirm: (name: string): string =>
    `Скрыть ${name}? Вы не будете видеть сообщения этого игрока, а он не сможет звать вас в игры. Вернуть можно в профиле.`,
  blockedTitle: 'Скрытые игроки',
  unblock: 'Вернуть',
  legalAgree: 'Продолжая, вы принимаете',
  legalTerms: 'Условия использования',
  legalAnd: 'и',
  legalPrivacy: 'Политику конфиденциальности',
  legalSupport: 'Поддержка',
  externalLevel: (lo: number, hi: number): string =>
    lo === hi ? `Игроки уровня ${lo.toFixed(2)}` : `Игроки уровня ${lo.toFixed(2)}–${hi.toFixed(2)}`,
  externalNoLevel: 'Уровень игроков неизвестен',
  externalHint: 'Матч клуба в Playtomic. Запись и оплата — там.',
  openInPlaytomic: 'Открыть в Playtomic',
  minutesShort: 'мин',
  noGamesTitle: 'На две недели вперёд игр пока нет',
  noGamesHint: 'Создайте первую и поделитесь ей в группе — остальные подтянутся.',
  join: 'Записаться',
  waitlist: 'В резерв',
  leave: 'Отменить запись',
  youAreIn: 'Вы в составе',
  youAreWaiting: 'Вы в резерве',
  full: 'Состав собран',
  freeSlots: (n: number) => `Свободно ${n}`,
  inWaitlist: (n: number) => `В резерве: ${n}`,
  level: 'Уровень',
  price: 'Цена',
  perPlayer: 'с человека',
  club: 'Клуб',
  date: 'Дата',
  time: 'Время',
  duration: 'Длительность',
  minutes: 'мин',
  players: 'Игроков',
  notes: 'Комментарий',
  courtBooked: 'Корт забронирован',
  courtNotBooked: 'Корт ещё не забронирован',
  createGame: 'Создать игру',
  formatLabel: 'Формат',
  kindGame: 'Игра',
  kindAmericano: 'Americano',
  kindMexicano: 'Mexicano',
  kindPairs: 'Турнир пар',
  kindHintGame: 'Обычная игра: собираем четвёрку, счёт вносят игроки',
  kindHintAmericano: 'Записываются по одному, каждый раунд — новый партнёр, личный зачёт по очкам',
  kindHintMexicano: 'Записываются по одному. 1-й раунд — жребий, дальше пары по таблице: 1+4 против 2+3, сильные играют с сильными. Личный зачёт по очкам',
  mixedToggle: 'Микст: пары М+Ж',
  mixedHint: 'Мест поровну для мужчин и женщин. Пары назначает организатор перед стартом.',
  mixedBadge: '🏆 Микст',
  genderLabel: 'Пол (для микст-турниров)',
  genderM: 'М',
  genderF: 'Ж',
  genderAskTitle: 'Это микст-турнир',
  genderAskHint: 'Мест поровну для мужчин и женщин. Вы играете как:',
  genderMan: 'Мужчина',
  genderWoman: 'Женщина',
  genderYours: 'Вы играете как',
  mixedFree: (m: number, f: number) => `Свободно: М ${m} · Ж ${f}`,
  freeSpotM: 'Свободное мужское место',
  freeSpotF: 'Свободное женское место',
  pairsTitle: 'Пары',
  pairsHint: 'Выберите партнёршу для каждого игрока. Пока пары назначены не все, турнир не начать.',
  pairsEmpty: 'Пары назначит организатор перед стартом.',
  pairNone: '— без пары —',
  pairsSaved: (done: number, total: number) => `Назначено пар: ${done} из ${total}`,
  kindHintPairs: 'Приложение соберёт ровные пары по уровню, каждая сыграет с каждой',
  playersCount: 'Участников',
  matchTo: 'Матч до',
  pointsUnit: 'очков',
  gamesUnit: 'геймов',
  gameTypeLabel: 'Тип игры',
  ratedGame: 'Рейтинговая',
  friendlyGame: 'Товарищеская',
  ratedGameHint: 'Счёт матча меняет уровень всех четверых.',
  friendlyGameHint: 'Без рейтинга: счёт можно внести для истории, уровень не изменится.',
  friendlyBadge: '🤝 Товарищеская',
  friendlyNote: '🤝 Товарищеский матч — уровень не меняется.',
  ratedToggle: 'Влияет на уровень участников',
  createTournament: 'Создать турнир',
  tournamentBadge: (kind: string): string =>
    kind === 'americano' ? '🏆 Americano' : kind === 'mexicano' ? '🏆 Mexicano' : kind === 'king' ? '👑 Король корта' : '🏆 Турнир пар',
  tournamentTitle: 'Турнир',
  startTournament: 'Начать турнир',
  startConfirm: 'Начать турнир? Запись закроется, приложение составит расписание и разошлёт участникам их первый корт.',
  resetTournament: 'Пересобрать расписание',
  resetConfirm: 'Удалить расписание и вернуть запись? Можно, пока не внесён ни один счёт.',
  finishTournament: 'Завершить турнир',
  finishConfirm: (missing: number) =>
    (missing ? `Без счёта ${missing} матч(ей) — они не попадут в итоги. ` : '') +
    'Завершить? Места и уровни зафиксируются, участники получат итоги.',
  roundN: (n: number) => `Раунд ${n}`,
  courtN: (n: number) => `Корт ${n}`,
  teamN: (n: number) => `Пара ${n}`,
  standings: 'Таблица',
  colPoints: 'Очки',
  colWins: 'Поб.',
  colDiff: '±',
  saveScore: 'Сохранить',
  clearScore: 'Стереть',
  progress: (done: number, total: number) => `Сыграно ${done} из ${total}`,
  statusRunning: 'Идёт',
  statusFinished: 'Завершён',
  registrationOpen: 'Идёт запись',
  paidMark: 'оплатил',
  notPaidMark: 'не оплатил',
  forecastHint: 'Изменение уровня — прогноз, итог зафиксируется при завершении.',
  yourMatch: 'вы',
  tapToScore: 'Нажмите на матч, чтобы внести счёт',
  scoreModeLabel: 'Как считать матч',
  scoreGames: 'Геймы',
  scorePoints: 'Очки, как americano',
  scoreHintGames: 'Матч до N геймов.',
  scoreHintPoints: 'Матч из N очков, каждый розыгрыш — очко.',
  rankHintGames: 'Места: победы → разница геймов → забитые геймы.',
  rankHintPoints: 'Места: сумма очков → победы → разница.',
  customValue: 'Своё',
  autoValue: 'Авто',
  courtsLabel: 'Кортов',
  roundsLabel: 'Раундов',
  roundsHint: 'Авто — каждый сыграет с каждым. Раунды подстраиваются так, чтобы все сыграли поровну.',
  restHint: (n: number) => `В каждом раунде отдыхают ${n} — по очереди, матчей у всех поровну.`,
  roundsUnlimited: 'Без лимита',
  editTournament: '✏️ Редактировать турнир',
  orgLockedTitle: '🔒 Турниры проводят организаторы',
  orgLockedText: 'Americano, Mexicano и турниры пар создают игроки с разрешением администратора и тренеры. Отправьте заявку — ответ придёт в Telegram.',
  orgRequest: 'Запросить доступ',
  orgPending: 'Заявка отправлена — ждём решения администратора.',
  orgRejected: 'Заявку пока не одобрили. Повторить можно через сутки.',
  orgSent: 'Заявка отправлена',
  orgBadge: '🏆 организатор',
  orgBadgePending: '🏆 заявка на турниры',
  orgApprove: 'Разрешить турниры',
  orgReject: 'Отклонить',
  orgRevoke: 'Снять право на турниры',
  orgSection: 'Турниры',
  editSectionWhen: 'Когда и где',
  editSectionMoney: 'Взнос и описание',
  editSectionFormat: 'Формат',
  priceEuro: 'Взнос с человека, €',
  priceNone: 'без взноса',
  lockedAfterStart: 'После старта не меняется',
  editNotifyHint: 'Участники получат сообщение, если изменятся время, клуб, взнос или очки за матч.',
  editSaved: 'Изменения сохранены',
  correctHint: 'Нажмите на матч, чтобы исправить счёт — места и уровни пересчитаются.',
  correctConfirm: 'Исправить счёт завершённого турнира? Места и уровни пересчитаются, участники, у кого они изменились, получат сообщение.',
  mexicanoRoundsHint: 'Авто — 6 раундов. «Без лимита» — играете, пока организатор не завершит. Раунды строятся по одному, по таблице.',
  planUnlimited: (players: number, courts: number) => `${players} участников · ${courts} корт(а) · раунды без лимита`,
  roundOf: (n: number, total: number | null) => (total ? `Раунд ${n} из ${total}` : `Раунд ${n}`),
  nextRound: (n: number) => `Построить ${n}-й раунд`,
  nextRoundHint: 'Пары составит таблица: в каждой четвёрке 1+4 против 2+3. Участники получат сообщение с кортом и партнёром.',
  undoRound: (n: number) => `Пересобрать ${n}-й раунд`,
  undoRoundConfirm: 'Убрать этот раунд? Пары составятся заново по текущей таблице — например, если поправили счёт.',
  planLine: (players: number, rounds: number, courts: number, per: number) =>
    `${players} участников · ${rounds} раундов · ${courts} корт(а) · по ${per} матчей у каждого`,
  tSettings: 'Настройки турнира',
  tSettingsLocked: 'Турнир идёт — меняются только очки за матч.',
  tSettingsLockedMex: 'Турнир идёт — меняются очки за матч и число раундов.',
  placesLabel: 'Мест',
  tabScore: 'Счёт',
  tabStats: 'Статистика',
  statsLive: 'Сейчас',
  statsFinal: 'Итог',
  roundShort: (n: number) => `Р${n}`,
  afterRound: (n: number) => `После ${n}-го раунда`,
  roundNotDone: 'раунд ещё идёт',
  colPlayer: 'Игрок',
  colPair: 'Пара',
  colWDL: 'В-Н-П',
  colDelta: 'Δ',
  restingNow: (names: string) => `Отдыхают: ${names}`,
  youRest: 'В этом раунде вы отдыхаете',
  liveHint: 'Обновляется в реальном времени',
  podiumTitle: 'Победители',
  resultsTitle: 'Итоги турнира',
  resultsHintBot: 'Бот пришлёт картинку и PDF — перешлите их в чат турнира.',
  resultsHintFiles: 'Откройте картинку или PDF и поделитесь ими в любом чате.',
  resultsToTelegram: 'Прислать в Telegram',
  resultsSent: 'Готово — бот пришлёт картинку и PDF в течение нескольких секунд. Перешлите их в чат турнира.',
  resultsImage: 'Картинка',
  resultsPdf: 'PDF',
  myResultTitle: 'Ваш результат',
  myPlace: (place: number, of: number) => `${place}-е место из ${of}`,
  myLine: (w: number, d: number, l: number, pf: number, pa: number, unit: string) =>
    `Матчей ${w + d + l} · В-Н-П ${w}-${d}-${l} · ${unit} ${pf}:${pa}`,
  myLevel: 'Уровень',
  totalsLine: (matches: number, pts: number, unit: string) => `Сыграно матчей: ${matches} · всего ${unit}: ${pts}`,
  bothScores: 'Введите счёт обеих пар',
  whyPairAvg: (team: string, opp: string) => `В среднем за турнир: ваша пара ${team}, соперники ${opp}.`,
  whyExpectedPoints: (e: number, a: number) => `Ожидалось ${e} % очков, взяли ${a} %.`,
  placeOf: (place: number, of: number) => `${place}-е место из ${of}`,
  matchesWon: (wins: number, total: number) => `побед ${wins} из ${total}`,
  onbLevelTitle: 'Какой у вас уровень?',
  onbLevelSub: 'Шкала как в Playtomic — от 0 до 7. Первые 10 матчей уточнят уровень.',
  onbPlaytomic: 'Знаю рейтинг на Playtomic',
  onbPlaytomicHint: 'Число рядом с вашим именем в профиле Playtomic, например 2.84.',
  onbPlaytomicPlaceholder: 'Например, 2.84',
  onbManual: 'Установить уровень вручную',
  onbManualHint: 'Выберите число, которое честнее всего описывает вашу игру.',
  onbSurvey: 'Не знаю свой уровень',
  onbSurveyHint: 'Ответьте на три вопроса — оценим примерно.',
  onbLevelError: 'Введите уровень от 0 до 7',
  levelBand: (level: number): string =>
    level < 1.5
      ? 'Только начинаю: учусь попадать по мячу'
      : level < 2.5
        ? 'Держу мяч в игре, стенки пока мешают'
        : level < 3.5
          ? 'Разыгрываю мяч, использую стенки, выхожу к сетке'
          : level < 4.5
            ? 'Стабильно играю у сетки, есть бандеха и вибора'
            : level < 5.5
              ? 'Играю турниры, держу темп, атакую смэшем'
              : 'Высокий турнирный уровень, тренер',
  adminPlayers: 'Игроки и уровни',
  adminHint: 'Нажмите на игрока, чтобы изменить уровень или право проводить турниры (🏆 — заявка или право). Игрок получит сообщение от бота.',
  adminSearch: 'Поиск по имени или нику',
  adminNoLevel: 'без уровня',
  adminSource: (source: string | null): string =>
    source === 'playtomic'
      ? 'Playtomic'
      : source === 'manual'
        ? 'вручную'
        : source === 'survey'
          ? 'опрос'
          : source === 'admin'
            ? 'админ'
            : '—',
  adminMatches: (n: number) => `матчей в рейтинге: ${n}`,
  adminNewLevel: 'Новый уровень',
  adminReset: 'Сбросить калибровку (первые 10 матчей снова меняют уровень сильнее)',
  adminSaved: 'Уровень сохранён',
  adminEmpty: 'Никого не нашли',
  onbTitle: 'Пара вопросов — и подберём игры по уровню',
  onbMonths: 'Сколько месяцев играете?',
  onbFrequency: 'Игр в месяц',
  onbBackground: 'Играли в теннис, сквош или бадминтон',
  onbSelf: 'Знаете свой уровень по Playtomic?',
  onbSide: 'Любимая сторона',
  left: 'Левая',
  right: 'Правая',
  both: 'Любая',
  save: 'Сохранить',
  yourLevel: 'Ваш уровень',
  gamesPlayed: 'Сыграно игр',
  reliability: 'Надёжность',
  loading: 'Загрузка…',
  back: 'Назад',
  levelWarning: 'Уровень игры не совпадает с вашим — потребуется согласие капитана',
  roster: 'Состав',
  waitlistTitle: 'Резерв',
  captain: 'капитан',
  freeSpot: 'Свободное место',
  route: 'Маршрут',
  clubBooking: 'Бронь в клубе',
  whatsapp: 'WhatsApp клуба',
  allDays: 'Все дни',
  today: 'Сегодня',
  tomorrow: 'Завтра',
  noGamesOnDay: 'В этот день игр нет. Создайте свою — остальные подтянутся.',
  chat: 'Чат',
  chatGame: 'Чат игры',
  chatTournament: 'Чат турнира',
  chatHint: 'Только для состава и резерва: где встречаемся, кто опаздывает, кто берёт мячи.',
  chatOpen: 'Открыть',
  chatNew: (n: number) => `${n} ${n % 10 === 1 && n % 100 !== 11 ? 'новое' : 'новых'}`,
  chatEmpty: 'Пока тихо. Напишите первым — где встречаемся, кто берёт мячи.',
  chatPlaceholder: 'Сообщение',
  chatSend: 'Отправить',
  chatEarlier: 'Показать более ранние',
  chatPin: 'Закрепить',
  chatUnpin: 'Открепить',
  chatDelete: 'Удалить',
  chatDeleteConfirm: 'Удалить сообщение?',
  chatPinned: 'Объявление капитана',
  chatPinHint: 'Нажмите на своё сообщение, чтобы закрепить его как объявление.',
  yesterday: 'Вчера',
  invite: 'Пригласить игроков',
  inviteTitle: 'Кого позвать',
  inviteSearch: 'Поиск по имени',
  inviteHint:
    'Игрок получит сообщение от бота и увидит приглашение в приложении. Место не бронируется: кто первым согласится, тот и в составе.',
  inviteHintFull: 'Состав собран — приглашённые попадут в резерв.',
  inviteBtn: 'Позвать',
  invitedMark: 'Приглашён',
  declinedMark: 'Отказался',
  playedTogether: 'играли вместе',
  levelOff: 'уровень вне рамок игры',
  noCandidates: 'Никого не нашли. Позовите человека личной ссылкой ниже.',
  notInApp: 'Нет в приложении?',
  notInAppHint:
    'Отправьте личную ссылку: человек ответит на 4 вопроса и попадёт сразу в эту игру, а вы узнаете, что он записался.',
  viaTelegram: 'В Telegram',
  viaWhatsApp: 'В WhatsApp',
  inviteLinkText: (when: string, club: string, tournament: boolean) =>
    `Зову тебя на ${tournament ? 'турнир по паделу' : 'падел'}: ${when}, ${club}. Записывайся по ссылке`,
  invitesYou: (who: string, kind: string) =>
    `${who} зовёт вас на ${kind === 'game' ? 'игру' : kind === 'training' ? 'групповую тренировку' : kind === 'americano' ? 'турнир Americano' : kind === 'mexicano' ? 'турнир Mexicano' : kind === 'king' ? 'турнир «Король корта»' : 'турнир пар'}`,
  inviteGo: 'Иду',
  inviteGoWaitlist: 'Встать в резерв',
  inviteNo: 'Не смогу',
  inviteMore: 'Подробнее',
  inviteLater: 'Позже',
  inviteCount: (i: number, n: number) => `${i} из ${n}`,
  invitedWaiting: (who: string) => `позвал(а) ${who} · ждём ответа`,
  doneClose: 'Готово',
  share: 'Поделиться в чат',
  markBooked: 'Отметить: корт забронирован',
  markNotBooked: 'Снять отметку брони',
  cancelGame: 'Отменить игру',
  cancelGameConfirm: 'Отменить игру для всех? Записавшимся придёт уведомление.',
  leaveConfirm: 'Отменить запись? Если до игры меньше 12 часов, это снизит надёжность.',
  gameCancelled: 'Игра отменена',
  notFound: 'Игра не найдена или уже прошла',
  lowReliability: 'часто отменяет',
  shareText: (when: string, club: string, lo: string, hi: string, free: number) =>
    `Падел ${when}, ${club}. Уровень ${lo}–${hi}. ` +
    (free > 0 ? `Свободно мест: ${free}.` : 'Состав собран, можно в резерв.'),
  result: 'Результат',
  enterScore: 'Внести счёт',
  scoreHint: 'Меняли пары — вносите каждый матч отдельно. Счёт подтверждает соперник.',
  partner: 'Ваш партнёр',
  opponents: 'Соперники',
  us: 'Мы',
  them: 'Они',
  setN: (n: number) => `Сет ${n}`,
  superTiebreak: 'Супертай-брейк',
  submitScore: 'Отправить на подтверждение',
  confirmScore: 'Подтвердить',
  disputeScore: 'Оспорить',
  withdrawScore: 'Отозвать',
  disputeConfirm: 'Оспорить счёт? Рейтинг не изменится, счёт нужно будет внести заново.',
  pendingScore: (h: number) => `Ждёт ответа · ${h} ч`,
  confirmedScore: 'Подтверждён',
  disputedScore: 'Оспорен',
  win: 'Победа',
  loss: 'Поражение',
  draw: 'Ничья',
  vs: 'против',
  withPartner: 'с',
  calibration: (n: number, total: number) => `Калибровка: ${n} из ${total} матчей`,
  calibrated: 'Уровень откалиброван',
  ratingHistory: 'История уровня',
  statMatches: 'Матчей',
  statWins: 'Побед',
  stat30d: 'За 30 дней',
  statGames: 'Геймы',
  levelChart: 'Уровень по матчам',
  chartEmpty: 'График появится после первого подтверждённого матча.',
  chartStart: 'старт',
  bestLevel: (v: string) => `лучший ${v}`,
  matchHistory: 'История матчей',
  noMatches: 'Здесь будут все ваши матчи со счётом — и подтверждённые, и ждущие ответа.',
  statusPending: 'ждёт подтверждения',
  statusDisputed: 'оспорен',
  changeTime: 'Изменить время или клуб',
  changeGameConfirm: (when: string, club: string): string => `Перенести игру: ${when}, ${club}? Участники получат уведомление.`,
  courtSpotsTitle: 'На корте',
  pairN: (n: number): string => `Пара ${n}`,
  spotLeft: 'слева',
  spotRight: 'справа',
  spotEmpty: 'свободно',
  spotTake: 'Сюда',
  spotHint: 'Нажмите на свободное место — так вы выберете партнёра и сторону. Нажмите на себя, чтобы освободить место.',
  spotHintCaptain: 'Капитан может переставить любого: нажмите на игрока, затем на место — игроки поменяются местами.',
  spotUnplaced: 'Ещё без места',
  spotMoving: (name: string): string => `Куда поставить: ${name}?`,
  changeTimeHint: 'Все участники получат сообщение о переносе (время или клуб) и сутки смогут выйти из состава без штрафа.',
  changeTimeConfirm: (when: string) => `Перенести игру на ${when}? Участники получат уведомление.`,
  timeChanged: 'Время изменено, участники уведомлены',
  shareWhatsApp: 'В WhatsApp',
  inviteFriendsTitle: 'Пригласить друзей',
  inviteFriendsHint: 'Чем больше игроков вашего уровня, тем быстрее собирается четвёрка. Бот скажет, когда друг присоединится.',
  inviteFriendsText: 'Играю в падел через Por4 — игры и турниры по уровню на Коста-Бланке. Присоединяйся:',
  invitedCount: (n: number) => `По вашей ссылке пришли: ${n}`,
  copyLink: 'Копировать ссылку',
  linkCopied: 'Ссылка скопирована',
  linkCopyFailed: 'Не удалось скопировать — выделите ссылку вручную',
  shareOutsideHint: 'Для WhatsApp и других мессенджеров — эта ссылка: по ней игра откроется, даже если Telegram покажет чат с ботом.',
  disputeUntil: (hours: number) => `Оспорить можно ещё ${hours} ч`,
  disputeConfirmed: 'Оспорить подтверждённый счёт? Изменение уровня у всех четверых будет отменено, счёт нужно внести заново.',
  gameHistory: 'История игр',
  noGameHistory: 'Здесь будут ваши прошедшие игры: где, с кем и с каким счётом.',
  noScoreYet: 'Счёт не внесён',
  playedWith: 'Играли',
  loginTitle: 'Падел по уровню на Коста-Бланке',
  loginSub: 'Соберите четвёрку за минуту. Войдите, чтобы видеть игры своего уровня.',
  loginTelegram: 'Войти через Telegram',
  loginTelegramHint: 'Если вы уже пользовались Por4 в Telegram — ваш уровень и история откроются здесь.',
  loginApple: 'Войти через Apple',
  loginWaiting: 'Откроется Telegram. Нажмите там «Да, войти» и вернитесь в приложение.',
  loginOpenAgain: 'Открыть Telegram ещё раз',
  loginCancel: 'Отмена',
  loginExpired: 'Время на вход истекло. Попробуйте ещё раз.',
  loginFailed: 'Не удалось войти. Попробуйте ещё раз.',
  accountTitle: 'Аккаунт',
  linkTelegram: 'Привязать Telegram',
  linkTelegramHint: 'Напоминания об играх и приглашения присылает бот в Telegram. Привяжите его, чтобы ничего не пропустить.',
  linkTaken: 'Этот Telegram уже связан с другим профилем Por4. Выйдите и войдите через Telegram — откроется прежний профиль.',
  linkDone: 'Telegram привязан',
  logout: 'Выйти',
  logoutConfirm: 'Выйти из аккаунта на этом устройстве?',
  deleteAccount: 'Удалить аккаунт',
  deleteAccountConfirm: 'Удалить аккаунт? Профиль и уровень будут стёрты, ваши будущие игры отменены. Это нельзя отменить.',
  deleteAccountConfirm2: 'Точно удалить? Восстановить аккаунт будет невозможно.',
  openGame: 'Открыть игру',
  noHistory: 'Уровень начнёт меняться после первого подтверждённого матча со счётом.',
  explain: (e: number, a: number) => `ожидалось ${e}% геймов, взяли ${a}%`,
  wonSet: 'Выиграли',
  lostSet: 'Проиграли',
  otherScore: 'Другой счёт',
  quickScore: 'Кнопки',
  scoreLabel: 'Счёт',
  thirdSet: 'Третий сет',
  fullSet: 'Полный сет',
  tbWinner: 'Кто взял тай-брейк',
  tbPoints: 'Очки, если помните',
  tbShort: 'ТБ',
  pickSet: 'Отметьте счёт сета',
  summary: (res: string, sa: number, sb: number, ga: number, gb: number) =>
    `${res} ${sa}:${sb} по сетам · ${ga}:${gb} по геймам`,
  previewTitle: 'Если соперник подтвердит',
  projected: 'прогноз',
  youLabel: 'вы',
  whyPair: (team: string, opp: string) => `Ваша пара ${team}, соперники ${opp}.`,
  whyPairOf: (team: string, opp: string) => `Пара ${team} против ${opp}.`,
  whyExpected: (e: number, a: number) => `Ожидалось ${e} % геймов, взяли ${a} %.`,
  reason: {
    better: 'Сыграли лучше ожидаемого — уровень растёт.',
    worse: 'Сыграли хуже ожидаемого — уровень снижается.',
    as_expected: 'Результат по силам — изменение минимальное.',
    win_guarded: 'Геймов меньше ожидаемого, но победа уровень не отнимает.',
    loss_guarded: 'Геймов больше ожидаемого, но поражение уровень не добавляет.',
  } as Record<string, string>,
  capped: 'Сработало ограничение: не больше 0.35 за матч.',
  calibrating: 'Идёт калибровка — первые 10 матчей меняют уровень сильнее.',
  ratingRule:
    'Уровень меняется по счёту матчей с учётом силы соперников. Победа над слабыми почти ничего не даёт, поражение от них стоит дорого.',
  // --- Заявки на корт (v0.35) ---
  bookCourt: 'Забронировать корт',
  bookTitle: (club: string): string => `Корт · ${club}`,
  bookDay: 'День',
  bookDuration: 'Длительность',
  bookCourtPick: 'Корт',
  bookAnyCourt: 'Любой',
  bookTime: 'Время',
  bookToday: 'сегодня',
  bookTomorrow: 'завтра',
  bookHours: (m: number): string => (m % 60 ? `${Math.floor(m / 60)},5 ч` : `${m / 60} ч`),
  bookNoTimes: 'На этот день свободного времени нет — выберите другой день.',
  bookFor: (when: string): string => `Корт для игры · ${when}`,
  bookAutoCourt: 'первый свободный корт',
  bookNote: 'Комментарий для клуба',
  bookNotePh: 'Необязательно: например, «нужны мячи»',
  bookRules: (reply: number, cancel: number): string =>
    `Клуб подтвердит заявку — обычно в течение ${reply} ч, ответ придёт в Telegram. Оплата — переводом по реквизитам клуба после подтверждения. Бесплатная отмена — за ${cancel} ч до начала.`,
  bookSend: 'Отправить заявку',
  bookSent: 'Заявка отправлена',
  bookSentHint: (when: string): string => `Клуб ответит до ${when}. Пока ждём ответа, это время держится за вами.`,
  bookMine: 'Мои брони',
  bookDone: 'Готово',
  bookFrom: (price: string): string => `от ${price}`,
  bookStatus: {
    requested: 'Ждём ответа клуба',
    confirmed: 'Подтверждено',
    declined: 'Клуб отказал',
    cancelled: 'Отменено',
    expired: 'Клуб не ответил',
  } as Record<string, string>,
  bookWaitUntil: (when: string): string => `Клуб ответит до ${when}`,
  bookPay: 'Оплата переводом',
  bookIban: 'IBAN',
  bookHolder: 'Получатель',
  bookConcept: 'Назначение',
  bookAmount: 'Сумма',
  bookCopied: 'Скопировано',
  bookFreeUntil: (when: string): string => `Бесплатная отмена — до ${when}`,
  bookLateNow: 'Отмена сейчас будет поздней',
  bookCancel: 'Отменить',
  bookWithdraw: 'Отозвать заявку',
  bookCancelAsk: 'Отменить бронь? Клуб получит сообщение.',
  bookCancelLateAsk: (h: number): string =>
    `До начала меньше ${h} ч — это поздняя отмена: клуб увидит пометку и сам решит вопрос оплаты, надёжность в профиле снизится. Отменить?`,
  bookWithdrawAsk: 'Отозвать заявку?',
  bookEmpty: 'Броней пока нет',
  bookPast: 'Прошедшие и отменённые',
  bookRoute: 'Маршрут',
  bookAgain: 'Выбрать другое время',
  bookLate: 'поздняя отмена',
  bookCancelledBy: { player: 'вы отменили', club: 'отменил клуб', calendar: 'отменил клуб' } as Record<string, string>,
  bookNoShow: 'неявка',
  bookHome: 'Бронь корта',
  bookHomeHint: (courts: number, price: string): string => `${courts} корт${courts === 1 ? '' : courts < 5 ? 'а' : 'ов'} · заявка онлайн${price ? ` · ${price}` : ''}`,
  bookDemo: 'демо',
  gameBookCourt: (club: string): string => `🎾 Запросить корт в ${club}`,
  gameBookPending: 'Заявка на корт отправлена — ждём ответа клуба',
  profileBookings: (n: number): string => (n ? `🎾 Мои брони · ${n}` : '🎾 Мои брони'),
  deskOpen: (club: string, n: number): string => `📋 Кабинет клуба · ${club}${n ? ` · заявок: ${n}` : ''}`,
  deskTitle: (club: string): string => `Кабинет · ${club}`,
  deskNew: (n: number): string => `Новые заявки · ${n}`,
  deskSchedule: 'Расписание',
  deskPast: 'Прошедшие, отказы и отмены',
  deskNothingNew: 'Новых заявок нет',
  deskConfirm: 'Подтвердить',
  deskDecline: 'Занято',
  deskCancel: 'Отменить бронь',
  deskCancelAsk: 'Отменить подтверждённую бронь? Игроку придёт сообщение.',
  deskNoShow: 'Не пришёл',
  deskNoShowUndo: 'Снять «не пришёл»',
  deskReply: (when: string): string => `ответить до ${when}`,
  deskLevel: (lvl: string, rel: number): string => `уровень ${lvl} · надёжность ${rel}%`,
  deskSettings: 'Настройки клуба',
  deskHours: (open: string, close: string, step: number): string => `Часы ${open}–${close}, шаг ${step} мин`,
  deskCancelRule: (h: number): string => `Бесплатная отмена — за ${h} ч`,
  deskReplyRule: (h: number): string => `Заявка ждёт ответа до ${h} ч (ночью срок не истекает)`,
  deskCalendarOn: 'Google Календарь подключён',
  deskCalendarSynced: (when: string): string => `занятость обновлена ${when}`,
  deskCalendarOff: 'Google Календарь не подключён',
  deskCalendarHow: (email: string): string =>
    `Чтобы подключить: Google Календарь → настройки календаря → «Открыть доступ» → добавьте ${email} с правом «Вносить изменения в мероприятия» и пришлите нам идентификатор календаря.`,
  deskCalendarNoSa: 'Подключение календаря настраивает Por4 — напишите нам.',
  deskCalendarError: 'Событие не попало в календарь',
  deskEmail: (email: string): string => `Дубль заявок на почту: ${email}`,
  deskLink: 'Ссылка для игроков',
  deskLinkHint: 'Отправьте жильцам в WhatsApp или поставьте на сайт — откроется бронь вашего клуба.',
  deskHidden: 'Демо: в общем списке бронь не видна, только по ссылке',
  deskEmpty: 'Броней пока нет',
  deskCopyLink: 'Копировать ссылку',
  deskCancelledBy: { player: 'игрок отменил', club: 'отменил клуб', calendar: 'удалено в календаре' } as Record<string, string>,
  // --- «Король корта» (v0.36) ---
  kindKing: '👑 Король корта',
  colWL: 'В-П',
  kindHintKing:
    'Постоянные пары на лестнице кортов: корт 1 — королевский. Победители поднимаются на корт выше, проигравшие спускаются. Раунд — по времени.',
  rankHintKing: 'Места — по лестнице: 1-е — победитель корта 1 в последнем раунде, 2-е — проигравший там же и так далее.',
  roundMinutesLabel: 'Минут на раунд',
  roundMinutesShort: (n: number): string => `раунд ${n} мин`,
  kingRoundHint: 'Организатор запускает таймер раунда — у всех на экране идёт отсчёт. Счёт — в геймах; при равенстве решает золотое очко.',
  kingLadderHint: 'Первая расстановка — по силе пар: сильнейшие на корте 1. Пары можно составить самим до старта.',
  goldenAsk: 'Ничья — кто выиграл золотое очко?',
  kingRestHint: 'Пар нечётное число: в каждом раунде одна пара отдыхает — проигравшие на нижнем корте',
  kingPairsHint: 'Можно составить пары самим. Остальных приложение соберёт по уровню (сильный со слабым) при старте.',
  kingPairsRest: 'Остальные пары приложение соберёт по уровню при старте.',
  kingPairsAuto: (n: number): string => `Без пары: ${n} — их соберём по уровню при старте`,
  timerRunning: 'идёт',
  timerOver: 'Время!',
  timerWaiting: 'Ждём старта раунда от организатора',
  timerRestart: 'Заново',
  timerStart: (round: number): string => `Старт раунда ${round}`,
  timerStop: 'Стоп',
  crownsHint: 'Раундов на корте 1',
  kingMovesHint: '👑 — остаётся на корте 1 · ▲ — на корт выше · ▼ — на корт ниже · ☕ — отдыхает · = — остаётся',
  kingNextHint: 'Победители поднимаются на корт выше, проигравшие спускаются. Таймер нового раунда — кнопкой «Старт раунда».',
  weekdays: ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'],
  locale: 'ru-RU',
}

type Dict = typeof ru

const en: Dict = {
  feed: 'Games',
  create: 'Create',
  profile: 'Profile',
  myLevelOnly: 'My level only',
  homeYou: 'You?',
  homeFree: 'Free',
  homeRoster: 'Line-up',
  courtBookedShort: 'court booked',
  homeSeats: (n: number, max: number): string => `${n} of ${max} spots`,
  homeCity: 'Town',
  homeAllTowns: 'All Marina',
  homeYourLevel: 'your level',
  homeWeek: 'Week',
  homeHaveGame: 'you have a game',
  homeNext: 'Your next game',
  homeAllMine: (n: number): string => `All mine · ${n}`,
  homeNoNext: "You haven't joined any game yet",
  homeInvites: (name: string): string => `${name} invites you to a game`,
  homeTournaments: 'Tournaments',
  homeMine: 'My games',
  homeOpen: 'Open games',
  homeSegLevel: 'My level',
  homeSegAll: 'All',
  homeSegMine: 'Mine',
  homeNothing: 'No matching games yet',
  dealsTitle: 'Padel deals',
  dealsAd: 'Affiliate links',
  adminDeals: 'Deals',
  adminDealUrl: 'Product link',
  adminDealFill: 'Fill from link',
  adminDealTitle: 'Title',
  adminDealShop: 'Shop',
  adminDealImage: 'Image (link)',
  adminDealPrice: 'Price, €',
  adminDealOld: 'Old price, €',
  adminDealCategory: 'Category',
  adminDealExpires: 'Valid until',
  adminDealActive: 'Show in the feed',
  adminDealNew: '+ New deal',
  adminDealDelete: 'Delete',
  adminDealDeleteConfirm: 'Delete this deal and its click stats?',
  adminDealClicks: (clicks: number, people: number): string => `${clicks} clicks · ${people} people`,
  adminDealHint: 'The strip shows in the feed while at least one deal is active. Links are marked as affiliate.',
  dealCategories: { palas: 'Rackets', zapatillas: 'Shoes', pelotas: 'Balls', ropa: 'Clothing', accesorios: 'Accessories' } as Record<string, string>,
  coachesTitle: 'Coaches',
  coachesAll: 'All',
  coachesHome: 'Coaches & trainings',
  trainingBadge: '🎓 Training',
  trainingGroup: 'Group training',
  coachLabel: 'Coach',
  coachFrom: (price) => `from ${price} €`,
  fmtName: { single: 'Private (1-on-1)', split: 'Split (two players)', group: 'Group' } as Record<string, string>,
  fmtUnit: { single: 'per hour', split: 'per hour for two', group: 'per person' } as Record<string, string>,
  coachLevels: (lo, hi) => `Students level ${lo}–${hi}`,
  coachYears: (n) => `${n} ${n === 1 ? 'year' : 'years'} of experience`,
  coachLanguages: 'Languages',
  coachClubs: 'Where they coach',
  coachUpcoming: 'Upcoming group trainings',
  coachRequestTitle: 'Book a training',
  coachRequestFormat: 'Format',
  coachRequestWhen: 'When suits you',
  whenChips: ['Morning', 'Afternoon', 'Evening', 'Weekdays', 'Weekend'],
  coachRequestMessage: 'Comment for the coach',
  coachRequestPlaceholder: 'E.g. playing for six months, want to fix my bandeja',
  coachRequestConsent:
    'The coach will see your name, level and comment, and once they accept, your Telegram. You agree on price, time and payment directly with the coach.',
  coachRequestSend: 'Send request',
  coachRequestSent: 'Request sent — the coach will reply on Telegram',
  coachReq: { new: 'Request sent · waiting for reply', accepted: 'The coach accepted and will message you', declined: "The coach couldn't take this request" } as Record<string, string>,
  coachWrite: 'Message the coach',
  coachRequestAgain: 'New request',
  coachesEmpty: 'No coaches here yet',
  coachesAnyLang: 'Any language',
  coachCta: '🎓 I am a coach',
  coachCtaHint: 'Publish a coach profile — players will send training requests straight to your Telegram.',
  coachNeedTelegram: 'Requests arrive on Telegram — link it in your profile first.',
  coachMyProfile: 'Coach profile',
  coachEdit: 'Edit profile',
  coachStatus: { pending: 'Under review', approved: 'Published', rejected: 'Not approved — edit and submit again', paused: 'Hidden by an administrator' } as Record<string, string>,
  coachInbox: (n) => (n ? `Requests · ${n} new` : 'Requests'),
  coachInboxEmpty: 'No requests yet. When a player sends one, it appears here and on Telegram.',
  coachAccept: 'Accept',
  coachDecline: "Can't do it",
  coachReqStatus: { new: 'New', accepted: 'Accepted', declined: 'Declined' } as Record<string, string>,
  coachContact: 'Message the player',
  coachContactViaBot: 'The bot sent you the player’s contact on Telegram',
  coachNewTraining: '+ Group training',
  coachName: 'Name on the card',
  coachBio: 'About you',
  coachBioHint: 'Experience, who you work with, how you help. At least 30 characters.',
  coachCert: 'Certificate or school',
  coachYearsLabel: 'Years of experience',
  coachLevelsLabel: 'Levels you work with',
  coachFormatsLabel: 'Formats and prices, €',
  coachClubsLabel: 'Clubs where you coach',
  coachLangsLabel: 'Languages',
  coachSubmit: 'Submit for review',
  coachSubmitted: 'Profile submitted for review — the answer will come on Telegram',
  coachDelete: 'Delete coach profile',
  coachDeleteConfirm: 'Delete your coach profile? Players will no longer see you in the section.',
  coachFillAll: 'Fill in name, description (30+ characters), languages, clubs and at least one format',
  adminCoaches: 'Coaches',
  adminApprove: 'Approve',
  adminReject: 'Reject',
  adminPause: 'Hide',
  adminRestore: 'Restore',
  adminCoachStats: (req, acc) => `requests ${req} · accepted ${acc}`,
  kindTraining: '🎓 Training',
  kindHintTraining: 'You coach, students sign up like for a game. The coach takes no spot, no score is entered, levels don’t change.',
  trainingFor: 'Who is it for',
  levelPresets: ['Beginners', 'Intermediate', 'Advanced', 'Any level'],
  createTraining: 'Create training',
  students: 'Students',
  chatTraining: 'Training chat',
  coachAbout: 'About the coach',
  removePlayer: 'Remove from game',
  removePlayerConfirm: (name: string): string =>
    `Remove ${name} from the game? They will get a message. Only you can add them back — via “Invite players”.`,
  removedNote: 'The captain removed you from this game. You can only come back by their invitation.',
  chatReport: 'Report',
  chatReportConfirm: 'Report this message? You won’t see it any more, and we’ll review it within 24 hours.',
  chatReported: 'Report sent. Thank you.',
  chatBlock: 'Hide author',
  chatBlockConfirm: (name: string): string =>
    `Hide ${name}? You won’t see this player’s messages and they won’t be able to invite you. You can undo this in your profile.`,
  blockedTitle: 'Hidden players',
  unblock: 'Unhide',
  legalAgree: 'By continuing you accept the',
  legalTerms: 'Terms of Use',
  legalAnd: 'and',
  legalPrivacy: 'Privacy Policy',
  legalSupport: 'Support',
  externalLevel: (lo: number, hi: number): string =>
    lo === hi ? `Players at level ${lo.toFixed(2)}` : `Players at level ${lo.toFixed(2)}–${hi.toFixed(2)}`,
  externalNoLevel: 'Players’ level unknown',
  externalHint: 'A club match on Playtomic. Join and pay there.',
  openInPlaytomic: 'Open in Playtomic',
  minutesShort: 'min',
  noGamesTitle: 'No games in the next two weeks',
  noGamesHint: 'Create the first one and share it in your group chat.',
  join: 'Join',
  waitlist: 'Waitlist',
  leave: 'Leave',
  youAreIn: "You're in",
  youAreWaiting: "You're on the waitlist",
  full: 'Full',
  freeSlots: (n) => `${n} spots left`,
  inWaitlist: (n) => `Waitlist: ${n}`,
  level: 'Level',
  price: 'Price',
  perPlayer: 'per player',
  club: 'Club',
  date: 'Date',
  time: 'Time',
  duration: 'Duration',
  minutes: 'min',
  players: 'Players',
  notes: 'Notes',
  courtBooked: 'Court booked',
  courtNotBooked: 'Court not booked yet',
  createGame: 'Create game',
  formatLabel: 'Format',
  kindGame: 'Game',
  kindAmericano: 'Americano',
  kindMexicano: 'Mexicano',
  kindPairs: 'Pairs tournament',
  kindHintGame: 'A regular game: find a four, players enter the score',
  kindHintAmericano: 'Sign up individually, new partner every round, individual points ranking',
  kindHintMexicano: 'Sign up individually. Round 1 is a draw, then pairs follow the standings: 1+4 vs 2+3, strong play strong. Individual points ranking',
  mixedToggle: 'Mixed: M+F pairs',
  mixedHint: 'Equal spots for men and women. The organiser sets the pairs before the start.',
  mixedBadge: '🏆 Mixed',
  genderLabel: 'Gender (for mixed tournaments)',
  genderM: 'M',
  genderF: 'F',
  genderAskTitle: 'This is a mixed tournament',
  genderAskHint: 'Spots are split equally between men and women. You play as:',
  genderMan: 'Man',
  genderWoman: 'Woman',
  genderYours: 'You play as',
  mixedFree: (m, f) => `Open: M ${m} · F ${f}`,
  freeSpotM: "Open men's spot",
  freeSpotF: "Open women's spot",
  pairsTitle: 'Pairs',
  pairsHint: 'Pick a partner for each player. The tournament cannot start until every pair is set.',
  pairsEmpty: 'The organiser will set the pairs before the start.',
  pairNone: '— no partner —',
  pairsSaved: (done, total) => `Pairs set: ${done} of ${total}`,
  kindHintPairs: 'The app builds balanced pairs by level, every pair plays every other',
  playersCount: 'Players',
  matchTo: 'Match to',
  pointsUnit: 'points',
  gamesUnit: 'games',
  gameTypeLabel: 'Game type',
  ratedGame: 'Rated',
  friendlyGame: 'Friendly',
  ratedGameHint: 'The score changes the level of all four players.',
  friendlyGameHint: 'No rating: you can log the score for history, levels stay the same.',
  friendlyBadge: '🤝 Friendly',
  friendlyNote: '🤝 Friendly match — levels do not change.',
  ratedToggle: 'Counts towards players’ levels',
  createTournament: 'Create tournament',
  tournamentBadge: (kind) => (kind === 'americano' ? '🏆 Americano' : kind === 'mexicano' ? '🏆 Mexicano' : kind === 'king' ? '👑 King of the Court' : '🏆 Pairs tournament'),
  tournamentTitle: 'Tournament',
  startTournament: 'Start tournament',
  startConfirm: 'Start the tournament? Sign-up closes, the app builds the schedule and sends everyone their first court.',
  resetTournament: 'Rebuild schedule',
  resetConfirm: 'Delete the schedule and reopen sign-up? Only possible before any score is entered.',
  finishTournament: 'Finish tournament',
  finishConfirm: (missing) =>
    (missing ? `${missing} match(es) without a score won’t count. ` : '') +
    'Finish? Places and levels will be final, players get the results.',
  roundN: (n) => `Round ${n}`,
  courtN: (n) => `Court ${n}`,
  teamN: (n) => `Pair ${n}`,
  standings: 'Standings',
  colPoints: 'Pts',
  colWins: 'W',
  colDiff: '±',
  saveScore: 'Save',
  clearScore: 'Clear',
  progress: (done, total) => `${done} of ${total} played`,
  statusRunning: 'In progress',
  statusFinished: 'Finished',
  registrationOpen: 'Sign-up open',
  paidMark: 'paid',
  notPaidMark: 'not paid',
  forecastHint: 'Level change is a forecast; it becomes final when the tournament ends.',
  yourMatch: 'you',
  tapToScore: 'Tap a match to enter the score',
  scoreModeLabel: 'How a match is scored',
  scoreGames: 'Games',
  scorePoints: 'Points, americano style',
  scoreHintGames: 'Match to N games.',
  scoreHintPoints: 'Match of N points, every rally counts.',
  rankHintGames: 'Ranking: wins → game difference → games won.',
  rankHintPoints: 'Ranking: total points → wins → difference.',
  customValue: 'Custom',
  autoValue: 'Auto',
  courtsLabel: 'Courts',
  roundsLabel: 'Rounds',
  roundsHint: 'Auto — everyone partners everyone. Rounds adjust so everyone plays the same number of matches.',
  restHint: (n) => `${n} rest each round — in turn, everyone plays the same number of matches.`,
  roundsUnlimited: 'No limit',
  editTournament: '✏️ Edit tournament',
  orgLockedTitle: '🔒 Tournaments are run by organizers',
  orgLockedText: 'Americano, Mexicano and pairs tournaments are created by players approved by the administrator and by coaches. Send a request — the answer comes in Telegram.',
  orgRequest: 'Request access',
  orgPending: 'Request sent — waiting for the administrator.',
  orgRejected: 'Your request wasn’t approved for now. You can try again in 24 hours.',
  orgSent: 'Request sent',
  orgBadge: '🏆 organizer',
  orgBadgePending: '🏆 tournament request',
  orgApprove: 'Allow tournaments',
  orgReject: 'Decline',
  orgRevoke: 'Remove tournament access',
  orgSection: 'Tournaments',
  editSectionWhen: 'When and where',
  editSectionMoney: 'Entry fee and description',
  editSectionFormat: 'Format',
  priceEuro: 'Entry fee per player, €',
  priceNone: 'free',
  lockedAfterStart: 'Can’t be changed after the start',
  editNotifyHint: 'Players get a message if the time, club, entry fee or points per match change.',
  editSaved: 'Changes saved',
  correctHint: 'Tap a match to correct its score — places and levels will be recalculated.',
  correctConfirm: 'Correct a score of a finished tournament? Places and levels will be recalculated; players whose results change get a message.',
  mexicanoRoundsHint: 'Auto — 6 rounds. “No limit” — play until the organizer finishes. Rounds are built one by one from the standings.',
  planUnlimited: (players, courts) => `${players} players · ${courts} court(s) · no round limit`,
  roundOf: (n, total) => (total ? `Round ${n} of ${total}` : `Round ${n}`),
  nextRound: (n) => `Build round ${n}`,
  nextRoundHint: 'Pairs follow the standings: in each group of four, 1+4 vs 2+3. Players get a message with court and partner.',
  undoRound: (n) => `Rebuild round ${n}`,
  undoRoundConfirm: 'Remove this round? Pairs will be rebuilt from the current standings — e.g. after fixing a score.',
  planLine: (players, rounds, courts, per) =>
    `${players} players · ${rounds} rounds · ${courts} court(s) · ${per} matches each`,
  tSettings: 'Tournament settings',
  tSettingsLocked: 'Tournament is running — only points per match can change.',
  tSettingsLockedMex: 'Tournament is running — points per match and number of rounds can change.',
  placesLabel: 'Spots',
  tabScore: 'Score',
  tabStats: 'Stats',
  statsLive: 'Live',
  statsFinal: 'Final',
  roundShort: (n) => `R${n}`,
  afterRound: (n) => `After round ${n}`,
  roundNotDone: 'round in progress',
  colPlayer: 'Player',
  colPair: 'Pair',
  colWDL: 'W-D-L',
  colDelta: 'Δ',
  restingNow: (names) => `Resting: ${names}`,
  youRest: 'You rest this round',
  liveHint: 'Updates in real time',
  podiumTitle: 'Winners',
  resultsTitle: 'Tournament results',
  resultsHintBot: 'The bot will send an image and a PDF — forward them to your tournament chat.',
  resultsHintFiles: 'Open the image or PDF and share it in any chat.',
  resultsToTelegram: 'Send to Telegram',
  resultsSent: 'Done — the bot will send the image and PDF in a few seconds. Forward them to your tournament chat.',
  resultsImage: 'Image',
  resultsPdf: 'PDF',
  myResultTitle: 'Your result',
  myPlace: (place, of) => `Place ${place} of ${of}`,
  myLine: (w, d, l, pf, pa, unit) => `${w + d + l} matches · W-D-L ${w}-${d}-${l} · ${unit} ${pf}:${pa}`,
  myLevel: 'Level',
  totalsLine: (matches, pts, unit) => `Matches played: ${matches} · total ${unit}: ${pts}`,
  bothScores: 'Enter both scores',
  whyPairAvg: (team, opp) => `Tournament average: your pair ${team}, opponents ${opp}.`,
  whyExpectedPoints: (e, a) => `Expected ${e}% of points, won ${a}%.`,
  placeOf: (place, of) => `Place ${place} of ${of}`,
  matchesWon: (wins, total) => `${wins} of ${total} won`,
  onbLevelTitle: "What's your level?",
  onbLevelSub: 'Same scale as Playtomic: 0 to 7. Your first 10 matches will fine-tune it.',
  onbPlaytomic: 'I know my Playtomic level',
  onbPlaytomicHint: 'The number next to your name in your Playtomic profile, e.g. 2.84.',
  onbPlaytomicPlaceholder: 'e.g. 2.84',
  onbManual: 'Set my level manually',
  onbManualHint: 'Pick the number that describes your game most honestly.',
  onbSurvey: "I don't know my level",
  onbSurveyHint: 'Answer three questions and we will estimate it.',
  onbLevelError: 'Enter a level from 0 to 7',
  levelBand: (level) =>
    level < 1.5
      ? 'Just starting: learning to hit the ball'
      : level < 2.5
        ? 'I keep the ball in play; walls still get in the way'
        : level < 3.5
          ? 'I rally, use the walls and come to the net'
          : level < 4.5
            ? 'Solid at the net, with bandeja and víbora'
            : level < 5.5
              ? 'I play tournaments, keep the pace, finish with smashes'
              : 'High tournament level, coach',
  adminPlayers: 'Players and levels',
  adminHint: 'Tap a player to change their level or tournament access (🏆 — request or access). The player gets a message from the bot.',
  adminSearch: 'Search by name or username',
  adminNoLevel: 'no level',
  adminSource: (source) =>
    source === 'playtomic'
      ? 'Playtomic'
      : source === 'manual'
        ? 'manual'
        : source === 'survey'
          ? 'survey'
          : source === 'admin'
            ? 'admin'
            : '—',
  adminMatches: (n) => `rated matches: ${n}`,
  adminNewLevel: 'New level',
  adminReset: 'Reset calibration (the first 10 matches move the level more again)',
  adminSaved: 'Level saved',
  adminEmpty: 'Nobody found',
  onbTitle: 'A few questions to match your level',
  onbMonths: 'Months playing',
  onbFrequency: 'Games per month',
  onbBackground: 'Played tennis, squash or badminton',
  onbSelf: 'Know your Playtomic level?',
  onbSide: 'Preferred side',
  left: 'Left',
  right: 'Right',
  both: 'Any',
  save: 'Save',
  yourLevel: 'Your level',
  gamesPlayed: 'Games played',
  reliability: 'Reliability',
  loading: 'Loading…',
  back: 'Back',
  levelWarning: "Level doesn't match yours — captain approval needed",
  roster: 'Players',
  waitlistTitle: 'Waitlist',
  captain: 'captain',
  freeSpot: 'Open spot',
  route: 'Directions',
  clubBooking: 'Club booking',
  whatsapp: 'Club WhatsApp',
  allDays: 'All days',
  today: 'Today',
  tomorrow: 'Tomorrow',
  noGamesOnDay: 'No games on this day. Create one — others will join.',
  chat: 'Chat',
  chatGame: 'Game chat',
  chatTournament: 'Tournament chat',
  chatHint: 'Players and waitlist only: where to meet, who is late, who brings balls.',
  chatOpen: 'Open',
  chatNew: (n) => `${n} new`,
  chatEmpty: 'Quiet so far. Say where to meet or who brings the balls.',
  chatPlaceholder: 'Message',
  chatSend: 'Send',
  chatEarlier: 'Show earlier messages',
  chatPin: 'Pin',
  chatUnpin: 'Unpin',
  chatDelete: 'Delete',
  chatDeleteConfirm: 'Delete this message?',
  chatPinned: "Captain's note",
  chatPinHint: 'Tap your message to pin it as a note for everyone.',
  yesterday: 'Yesterday',
  invite: 'Invite players',
  inviteTitle: 'Who to invite',
  inviteSearch: 'Search by name',
  inviteHint:
    'The player gets a message from the bot and sees the invite in the app. No spot is held: first to accept gets in.',
  inviteHintFull: 'The game is full — invited players go to the waitlist.',
  inviteBtn: 'Invite',
  invitedMark: 'Invited',
  declinedMark: 'Declined',
  playedTogether: 'played together',
  levelOff: 'level outside the range',
  noCandidates: 'Nobody found. Send a personal link below instead.',
  notInApp: 'Not in the app yet?',
  notInAppHint:
    'Send a personal link: they answer 4 questions and land right in this game, and you get told when they join.',
  viaTelegram: 'Telegram',
  viaWhatsApp: 'WhatsApp',
  inviteLinkText: (when, club, tournament) =>
    `Join me for ${tournament ? 'a padel tournament' : 'padel'}: ${when}, ${club}. Sign up here`,
  invitesYou: (who, kind) =>
    `${who} invites you to ${kind === 'game' ? 'a game' : kind === 'training' ? 'a group training' : kind === 'americano' ? 'an Americano tournament' : kind === 'mexicano' ? 'a Mexicano tournament' : kind === 'king' ? 'a King of the Court tournament' : 'a pairs tournament'}`,
  inviteGo: "I'm in",
  inviteGoWaitlist: 'Join waitlist',
  inviteNo: "Can't make it",
  inviteMore: 'Details',
  inviteLater: 'Later',
  inviteCount: (i, n) => `${i} of ${n}`,
  invitedWaiting: (who) => `invited by ${who} · waiting`,
  doneClose: 'Done',
  share: 'Share to chat',
  markBooked: 'Mark court as booked',
  markNotBooked: 'Unmark booking',
  cancelGame: 'Cancel game',
  cancelGameConfirm: 'Cancel the game for everyone? Players will be notified.',
  leaveConfirm: 'Leave the game? Leaving less than 12 hours before lowers your reliability.',
  gameCancelled: 'Game cancelled',
  notFound: 'Game not found or already over',
  lowReliability: 'often cancels',
  shareText: (when, club, lo, hi, free) =>
    `Padel ${when}, ${club}. Level ${lo}–${hi}. ` +
    (free > 0 ? `${free} spots left.` : 'Full — waitlist open.'),
  result: 'Result',
  enterScore: 'Enter score',
  scoreHint: 'Switched partners? Enter each match separately. An opponent confirms the score.',
  partner: 'Your partner',
  opponents: 'Opponents',
  us: 'Us',
  them: 'Them',
  setN: (n) => `Set ${n}`,
  superTiebreak: 'Super tie-break',
  submitScore: 'Send for confirmation',
  confirmScore: 'Confirm',
  disputeScore: 'Dispute',
  withdrawScore: 'Withdraw',
  disputeConfirm: 'Dispute the score? Ratings stay unchanged; the score must be entered again.',
  pendingScore: (h) => `Awaiting reply · ${h}h`,
  confirmedScore: 'Confirmed',
  disputedScore: 'Disputed',
  win: 'Win',
  loss: 'Loss',
  draw: 'Draw',
  vs: 'vs',
  withPartner: 'with',
  calibration: (n, total) => `Calibration: ${n} of ${total} matches`,
  calibrated: 'Level calibrated',
  ratingHistory: 'Level history',
  statMatches: 'Matches',
  statWins: 'Wins',
  stat30d: 'Last 30 days',
  statGames: 'Games',
  levelChart: 'Level by match',
  chartEmpty: 'The chart appears after your first confirmed match.',
  chartStart: 'start',
  bestLevel: (v) => `best ${v}`,
  matchHistory: 'Match history',
  noMatches: 'All your matches with a score will appear here — confirmed and pending.',
  statusPending: 'awaiting confirmation',
  statusDisputed: 'disputed',
  changeTime: 'Change time or club',
  changeGameConfirm: (when, club) => `Move the game to ${when}, ${club}? Players will be notified.`,
  courtSpotsTitle: 'On court',
  pairN: (n) => `Pair ${n}`,
  spotLeft: 'left',
  spotRight: 'right',
  spotEmpty: 'free',
  spotTake: 'Here',
  spotHint: 'Tap a free spot to pick your partner and side. Tap yourself to free the spot.',
  spotHintCaptain: 'The captain can move anyone: tap a player, then a spot — they swap places.',
  spotUnplaced: 'No spot yet',
  spotMoving: (name) => `Where should ${name} play?`,
  changeTimeHint: 'Everyone gets a message about the change and can leave without a penalty for 24 hours.',
  changeTimeConfirm: (when) => `Move the game to ${when}? Players will be notified.`,
  timeChanged: 'Time changed, players notified',
  shareWhatsApp: 'WhatsApp',
  inviteFriendsTitle: 'Invite friends',
  inviteFriendsHint: 'The more players at your level, the faster a four comes together. The bot will tell you when a friend joins.',
  inviteFriendsText: 'I play padel with Por4 — games and tournaments by level on the Costa Blanca. Join me:',
  invitedCount: (n: number) => `Joined with your link: ${n}`,
  copyLink: 'Copy link',
  linkCopied: 'Link copied',
  linkCopyFailed: 'Could not copy — select the link manually',
  shareOutsideHint: 'For WhatsApp and other messengers use this link: it opens the game even if Telegram shows the bot chat.',
  disputeUntil: (hours) => `Can be disputed for ${hours} more h`,
  disputeConfirmed: 'Dispute a confirmed score? The level change of all four players will be reverted and the score must be entered again.',
  gameHistory: 'Game history',
  noGameHistory: 'Your past games will appear here: where, with whom and the score.',
  noScoreYet: 'No score entered',
  playedWith: 'Players',
  loginTitle: 'Padel by level on the Costa Blanca',
  loginSub: 'Find your four in a minute. Sign in to see games at your level.',
  loginTelegram: 'Sign in with Telegram',
  loginTelegramHint: 'If you already used Por4 in Telegram, your level and history will be here.',
  loginApple: 'Sign in with Apple',
  loginWaiting: 'Telegram will open. Tap “Yes, sign in” there and come back to the app.',
  loginOpenAgain: 'Open Telegram again',
  loginCancel: 'Cancel',
  loginExpired: 'Sign-in timed out. Please try again.',
  loginFailed: 'Could not sign in. Please try again.',
  accountTitle: 'Account',
  linkTelegram: 'Link Telegram',
  linkTelegramHint: 'Game reminders and invites are sent by the Telegram bot. Link it so you do not miss anything.',
  linkTaken: 'This Telegram is already linked to another Por4 profile. Sign out and sign in with Telegram to open it.',
  linkDone: 'Telegram linked',
  logout: 'Sign out',
  logoutConfirm: 'Sign out on this device?',
  deleteAccount: 'Delete account',
  deleteAccountConfirm: 'Delete your account? Your profile and level will be erased and your upcoming games cancelled. This cannot be undone.',
  deleteAccountConfirm2: 'Delete for sure? The account cannot be restored.',
  openGame: 'Open game',
  noHistory: 'Your level starts moving after your first confirmed match with a score.',
  explain: (e, a) => `expected ${e}% of games, won ${a}%`,
  wonSet: 'Won',
  lostSet: 'Lost',
  otherScore: 'Other score',
  quickScore: 'Buttons',
  scoreLabel: 'Score',
  thirdSet: 'Third set',
  fullSet: 'Full set',
  tbWinner: 'Who won the tie-break',
  tbPoints: 'Points, if you remember',
  tbShort: 'TB',
  pickSet: 'Tap the set score',
  summary: (res, sa, sb, ga, gb) => `${res} ${sa}:${sb} in sets · ${ga}:${gb} in games`,
  previewTitle: 'If an opponent confirms',
  projected: 'forecast',
  youLabel: 'you',
  whyPair: (team, opp) => `Your pair ${team}, opponents ${opp}.`,
  whyPairOf: (team, opp) => `Pair ${team} vs ${opp}.`,
  whyExpected: (e, a) => `Expected ${e}% of games, won ${a}%.`,
  reason: {
    better: 'Played better than expected — level goes up.',
    worse: 'Played worse than expected — level goes down.',
    as_expected: 'Result matched the odds — minimal change.',
    win_guarded: 'Fewer games than expected, but a win never lowers your level.',
    loss_guarded: 'More games than expected, but a loss never raises your level.',
  },
  capped: 'Capped: at most 0.35 per match.',
  calibrating: 'Calibrating — your first 10 matches move the level faster.',
  ratingRule:
    'Your level moves with match scores, weighted by opponent strength. Beating weaker players earns little; losing to them costs a lot.',
  // --- Court requests (v0.35) ---
  bookCourt: 'Book a court',
  bookTitle: (club) => `Court · ${club}`,
  bookDay: 'Day',
  bookDuration: 'Duration',
  bookCourtPick: 'Court',
  bookAnyCourt: 'Any',
  bookTime: 'Time',
  bookToday: 'today',
  bookTomorrow: 'tomorrow',
  bookHours: (m) => (m % 60 ? `${Math.floor(m / 60)}.5 h` : `${m / 60} h`),
  bookNoTimes: 'No free time on this day — pick another day.',
  bookFor: (when) => `Court for the game · ${when}`,
  bookAutoCourt: 'first free court',
  bookNote: 'Note for the club',
  bookNotePh: 'Optional, e.g. “we need balls”',
  bookRules: (reply, cancel) =>
    `The club confirms your request, usually within ${reply} h — the answer comes in Telegram. Pay by bank transfer to the club after confirmation. Free cancellation up to ${cancel} h before.`,
  bookSend: 'Send request',
  bookSent: 'Request sent',
  bookSentHint: (when) => `The club will reply by ${when}. The slot is held for you meanwhile.`,
  bookMine: 'My bookings',
  bookDone: 'Done',
  bookFrom: (price) => `from ${price}`,
  bookStatus: {
    requested: 'Waiting for the club',
    confirmed: 'Confirmed',
    declined: 'Declined by the club',
    cancelled: 'Cancelled',
    expired: 'No reply from the club',
  },
  bookWaitUntil: (when) => `The club will reply by ${when}`,
  bookPay: 'Bank transfer',
  bookIban: 'IBAN',
  bookHolder: 'Holder',
  bookConcept: 'Reference',
  bookAmount: 'Amount',
  bookCopied: 'Copied',
  bookFreeUntil: (when) => `Free cancellation until ${when}`,
  bookLateNow: 'Cancelling now counts as late',
  bookCancel: 'Cancel',
  bookWithdraw: 'Withdraw request',
  bookCancelAsk: 'Cancel the booking? The club will be notified.',
  bookCancelLateAsk: (h) =>
    `Less than ${h} h to go — this is a late cancellation: the club will see it and decide about payment, and your reliability drops. Cancel?`,
  bookWithdrawAsk: 'Withdraw the request?',
  bookEmpty: 'No bookings yet',
  bookPast: 'Past and cancelled',
  bookRoute: 'Directions',
  bookAgain: 'Pick another time',
  bookLate: 'late cancellation',
  bookCancelledBy: { player: 'you cancelled', club: 'cancelled by the club', calendar: 'cancelled by the club' },
  bookNoShow: 'no-show',
  bookHome: 'Court booking',
  bookHomeHint: (courts, price) => `${courts} court${courts === 1 ? '' : 's'} · online request${price ? ` · ${price}` : ''}`,
  bookDemo: 'demo',
  gameBookCourt: (club) => `🎾 Request a court at ${club}`,
  gameBookPending: 'Court request sent — waiting for the club',
  profileBookings: (n) => (n ? `🎾 My bookings · ${n}` : '🎾 My bookings'),
  deskOpen: (club, n) => `📋 Club desk · ${club}${n ? ` · ${n} new` : ''}`,
  deskTitle: (club) => `Desk · ${club}`,
  deskNew: (n) => `New requests · ${n}`,
  deskSchedule: 'Schedule',
  deskPast: 'Past, declined and cancelled',
  deskNothingNew: 'No new requests',
  deskConfirm: 'Confirm',
  deskDecline: 'Taken',
  deskCancel: 'Cancel booking',
  deskCancelAsk: 'Cancel this confirmed booking? The player will be notified.',
  deskNoShow: 'No-show',
  deskNoShowUndo: 'Undo no-show',
  deskReply: (when) => `reply by ${when}`,
  deskLevel: (lvl, rel) => `level ${lvl} · reliability ${rel}%`,
  deskSettings: 'Club settings',
  deskHours: (open, close, step) => `Hours ${open}–${close}, ${step}-min steps`,
  deskCancelRule: (h) => `Free cancellation up to ${h} h before`,
  deskReplyRule: (h) => `Requests wait up to ${h} h for a reply (deadlines never fall at night)`,
  deskCalendarOn: 'Google Calendar connected',
  deskCalendarSynced: (when) => `availability updated ${when}`,
  deskCalendarOff: 'Google Calendar not connected',
  deskCalendarHow: (email) =>
    `To connect: Google Calendar → calendar settings → “Share with specific people” → add ${email} with “Make changes to events” and send us the calendar ID.`,
  deskCalendarNoSa: 'Por4 sets up the calendar connection — write to us.',
  deskCalendarError: 'The event did not reach the calendar',
  deskEmail: (email) => `Requests also go to ${email}`,
  deskLink: 'Link for players',
  deskLinkHint: 'Send it to residents on WhatsApp or put it on your website — it opens your club’s booking.',
  deskHidden: 'Demo: booking is hidden from the list, link only',
  deskEmpty: 'No bookings yet',
  deskCopyLink: 'Copy link',
  deskCancelledBy: { player: 'player cancelled', club: 'cancelled by the club', calendar: 'deleted in the calendar' },
  // --- King of the Court (v0.36) ---
  kindKing: '👑 King of the Court',
  colWL: 'W-L',
  kindHintKing:
    'Fixed pairs on a ladder of courts: court 1 is the king’s court. Winners move up a court, losers move down. Rounds are timed.',
  rankHintKing: 'Places follow the ladder: 1st — the court 1 winner in the last round, 2nd — the loser there, and so on.',
  roundMinutesLabel: 'Minutes per round',
  roundMinutesShort: (n) => `${n}-min rounds`,
  kingRoundHint: 'The organiser starts the round timer and everyone sees the countdown. Score in games; a tie is decided by a golden point.',
  kingLadderHint: 'Start order by pair strength: the strongest on court 1. You can set pairs yourself before the start.',
  goldenAsk: 'Tie — who won the golden point?',
  kingRestHint: 'Odd number of pairs: one pair rests each round — the losers on the bottom court',
  kingPairsHint: 'You can set pairs yourself. The app pairs the rest by level (strong with weaker) at the start.',
  kingPairsRest: 'The app pairs the rest by level at the start.',
  kingPairsAuto: (n) => `Without a pair: ${n} — paired by level at the start`,
  timerRunning: 'running',
  timerOver: 'Time!',
  timerWaiting: 'Waiting for the organiser to start the round',
  timerRestart: 'Restart',
  timerStart: (round) => `Start round ${round}`,
  timerStop: 'Stop',
  crownsHint: 'Rounds on court 1',
  kingMovesHint: '👑 — stays on court 1 · ▲ — up a court · ▼ — down a court · ☕ — rests · = — stays',
  kingNextHint: 'Winners move up a court, losers move down. Start the new round’s timer with “Start round”.',
  weekdays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  locale: 'en-GB',
}

const es: Dict = {
  feed: 'Partidas',
  create: 'Crear',
  profile: 'Perfil',
  myLevelOnly: 'Solo mi nivel',
  homeYou: '¿Tú?',
  homeFree: 'Libre',
  homeRoster: 'Jugadores',
  courtBookedShort: 'pista reservada',
  homeSeats: (n: number, max: number): string => `${n} de ${max} plazas`,
  homeCity: 'Ciudad',
  homeAllTowns: 'Toda la Marina',
  homeYourLevel: 'tu nivel',
  homeWeek: 'Semana',
  homeHaveGame: 'tienes partido',
  homeNext: 'Tu próximo partido',
  homeAllMine: (n: number): string => `Todos los míos · ${n}`,
  homeNoNext: 'Aún no te has apuntado a ningún partido',
  homeInvites: (name: string): string => `${name} te invita a un partido`,
  homeTournaments: 'Torneos',
  homeMine: 'Mis partidos',
  homeOpen: 'Partidos abiertos',
  homeSegLevel: 'Mi nivel',
  homeSegAll: 'Todos',
  homeSegMine: 'Míos',
  homeNothing: 'Aún no hay partidos que encajen',
  dealsTitle: 'Ofertas de pádel',
  dealsAd: 'Enlaces de afiliado',
  adminDeals: 'Ofertas',
  adminDealUrl: 'Enlace del producto',
  adminDealFill: 'Rellenar desde el enlace',
  adminDealTitle: 'Título',
  adminDealShop: 'Tienda',
  adminDealImage: 'Imagen (enlace)',
  adminDealPrice: 'Precio, €',
  adminDealOld: 'Precio anterior, €',
  adminDealCategory: 'Categoría',
  adminDealExpires: 'Válida hasta',
  adminDealActive: 'Mostrar en la lista',
  adminDealNew: '+ Nueva oferta',
  adminDealDelete: 'Eliminar',
  adminDealDeleteConfirm: '¿Eliminar la oferta y sus estadísticas de clics?',
  adminDealClicks: (clicks: number, people: number): string => `${clicks} clics · ${people} personas`,
  adminDealHint: 'La franja aparece mientras haya al menos una oferta activa. Los enlaces se marcan como de afiliado.',
  dealCategories: { palas: 'Palas', zapatillas: 'Zapatillas', pelotas: 'Pelotas', ropa: 'Ropa', accesorios: 'Accesorios' } as Record<string, string>,
  coachesTitle: 'Entrenadores',
  coachesAll: 'Todos',
  coachesHome: 'Entrenadores y clases',
  trainingBadge: '🎓 Entrenamiento',
  trainingGroup: 'Entrenamiento en grupo',
  coachLabel: 'Entrenador',
  coachFrom: (price) => `desde ${price} €`,
  fmtName: { single: 'Individual', split: 'Para dos', group: 'En grupo' } as Record<string, string>,
  fmtUnit: { single: 'la hora', split: 'la hora, para dos', group: 'por persona' } as Record<string, string>,
  coachLevels: (lo, hi) => `Alumnos de nivel ${lo}–${hi}`,
  coachYears: (n) => `${n} ${n === 1 ? 'año' : 'años'} de experiencia`,
  coachLanguages: 'Idiomas',
  coachClubs: 'Dónde entrena',
  coachUpcoming: 'Próximos entrenamientos en grupo',
  coachRequestTitle: 'Pedir una clase',
  coachRequestFormat: 'Formato',
  coachRequestWhen: 'Cuándo te va bien',
  whenChips: ['Mañana', 'Mediodía', 'Tarde', 'Entre semana', 'Fin de semana'],
  coachRequestMessage: 'Comentario para el entrenador',
  coachRequestPlaceholder: 'Ej.: juego desde hace seis meses, quiero mejorar la bandeja',
  coachRequestConsent:
    'El entrenador verá tu nombre, nivel y comentario y, si acepta, tu Telegram. El precio, la hora y el pago los acordáis directamente.',
  coachRequestSend: 'Enviar solicitud',
  coachRequestSent: 'Solicitud enviada: el entrenador responderá por Telegram',
  coachReq: { new: 'Solicitud enviada · esperando respuesta', accepted: 'El entrenador ha aceptado y te escribirá', declined: 'El entrenador no ha podido aceptar' } as Record<string, string>,
  coachWrite: 'Escribir al entrenador',
  coachRequestAgain: 'Nueva solicitud',
  coachesEmpty: 'Aún no hay entrenadores aquí',
  coachesAnyLang: 'Cualquier idioma',
  coachCta: '🎓 Soy entrenador',
  coachCtaHint: 'Publica tu perfil de entrenador: los jugadores te enviarán solicitudes de clase directamente a Telegram.',
  coachNeedTelegram: 'Las solicitudes llegan por Telegram: vincúlalo primero en tu perfil.',
  coachMyProfile: 'Perfil de entrenador',
  coachEdit: 'Editar perfil',
  coachStatus: { pending: 'En revisión', approved: 'Publicado', rejected: 'No aprobado: corrígelo y envíalo de nuevo', paused: 'Oculto por un administrador' } as Record<string, string>,
  coachInbox: (n) => (n ? `Solicitudes · ${n} ${n === 1 ? 'nueva' : 'nuevas'}` : 'Solicitudes'),
  coachInboxEmpty: 'Aún no hay solicitudes. Cuando un jugador envíe una, aparecerá aquí y en Telegram.',
  coachAccept: 'Aceptar',
  coachDecline: 'No puedo',
  coachReqStatus: { new: 'Nueva', accepted: 'Aceptada', declined: 'Rechazada' } as Record<string, string>,
  coachContact: 'Escribir al jugador',
  coachContactViaBot: 'El bot te ha enviado el contacto del jugador por Telegram',
  coachNewTraining: '+ Entrenamiento en grupo',
  coachName: 'Nombre en la tarjeta',
  coachBio: 'Sobre ti',
  coachBioHint: 'Experiencia, con quién trabajas, en qué ayudas. Mínimo 30 caracteres.',
  coachCert: 'Titulación o escuela',
  coachYearsLabel: 'Años de experiencia',
  coachLevelsLabel: 'Niveles con los que trabajas',
  coachFormatsLabel: 'Formatos y precios, €',
  coachClubsLabel: 'Clubes donde entrenas',
  coachLangsLabel: 'Idiomas',
  coachSubmit: 'Enviar a revisión',
  coachSubmitted: 'Perfil enviado a revisión: la respuesta llegará por Telegram',
  coachDelete: 'Eliminar perfil de entrenador',
  coachDeleteConfirm: '¿Eliminar tu perfil de entrenador? Los jugadores dejarán de verte en la sección.',
  coachFillAll: 'Rellena nombre, descripción (30+ caracteres), idiomas, clubes y al menos un formato',
  adminCoaches: 'Entrenadores',
  adminApprove: 'Aprobar',
  adminReject: 'Rechazar',
  adminPause: 'Ocultar',
  adminRestore: 'Restaurar',
  adminCoachStats: (req, acc) => `solicitudes ${req} · aceptadas ${acc}`,
  kindTraining: '🎓 Entrenamiento',
  kindHintTraining: 'Tú diriges, los alumnos se apuntan como a un partido. El entrenador no ocupa plaza, no se anota resultado y el nivel no cambia.',
  trainingFor: 'Para quién',
  levelPresets: ['Iniciación', 'Intermedio', 'Avanzado', 'Cualquier nivel'],
  createTraining: 'Crear entrenamiento',
  students: 'Alumnos',
  chatTraining: 'Chat del entrenamiento',
  coachAbout: 'Sobre el entrenador',
  removePlayer: 'Quitar del partido',
  removePlayerConfirm: (name: string): string =>
    `¿Quitar a ${name} del partido? Recibirá un aviso. Solo tú podrás volver a añadirle, desde «Invitar jugadores».`,
  removedNote: 'El capitán te ha quitado de este partido. Solo puedes volver con su invitación.',
  chatReport: 'Denunciar',
  chatReportConfirm: '¿Denunciar este mensaje? Dejarás de verlo y lo revisaremos en 24 horas.',
  chatReported: 'Denuncia enviada. Gracias.',
  chatBlock: 'Ocultar autor',
  chatBlockConfirm: (name: string): string =>
    `¿Ocultar a ${name}? No verás sus mensajes y no podrá invitarte a partidos. Puedes deshacerlo en tu perfil.`,
  blockedTitle: 'Jugadores ocultos',
  unblock: 'Mostrar',
  legalAgree: 'Al continuar aceptas las',
  legalTerms: 'Condiciones de uso',
  legalAnd: 'y la',
  legalPrivacy: 'Política de privacidad',
  legalSupport: 'Soporte',
  externalLevel: (lo: number, hi: number): string =>
    lo === hi ? `Jugadores de nivel ${lo.toFixed(2)}` : `Jugadores de nivel ${lo.toFixed(2)}–${hi.toFixed(2)}`,
  externalNoLevel: 'Nivel de los jugadores desconocido',
  externalHint: 'Partido del club en Playtomic. Inscripción y pago allí.',
  openInPlaytomic: 'Abrir en Playtomic',
  minutesShort: 'min',
  noGamesTitle: 'Aún no hay partidas en las próximas dos semanas',
  noGamesHint: 'Crea la primera y compártela en tu grupo.',
  join: 'Apuntarme',
  waitlist: 'Lista de espera',
  leave: 'Salir',
  youAreIn: 'Estás dentro',
  youAreWaiting: 'Estás en lista de espera',
  full: 'Completo',
  freeSlots: (n) => `Quedan ${n}`,
  inWaitlist: (n) => `En espera: ${n}`,
  level: 'Nivel',
  price: 'Precio',
  perPlayer: 'por jugador',
  club: 'Club',
  date: 'Fecha',
  time: 'Hora',
  duration: 'Duración',
  minutes: 'min',
  players: 'Jugadores',
  notes: 'Notas',
  courtBooked: 'Pista reservada',
  courtNotBooked: 'Pista sin reservar',
  createGame: 'Crear partida',
  formatLabel: 'Formato',
  kindGame: 'Partida',
  kindAmericano: 'Americano',
  kindMexicano: 'Mexicano',
  kindPairs: 'Torneo por parejas',
  kindHintGame: 'Partida normal: se juntan cuatro, el resultado lo meten los jugadores',
  kindHintAmericano: 'Inscripción individual, pareja nueva cada ronda, ranking individual por puntos',
  kindHintMexicano: 'Inscripción individual. 1.ª ronda por sorteo, luego parejas según la clasificación: 1+4 contra 2+3, los fuertes juegan con los fuertes. Ranking individual por puntos',
  mixedToggle: 'Mixto: parejas H+M',
  mixedHint: 'Plazas a partes iguales para hombres y mujeres. El organizador forma las parejas antes de empezar.',
  mixedBadge: '🏆 Mixto',
  genderLabel: 'Género (para torneos mixtos)',
  genderM: 'H',
  genderF: 'M',
  genderAskTitle: 'Es un torneo mixto',
  genderAskHint: 'Las plazas se reparten a partes iguales. Juegas como:',
  genderMan: 'Hombre',
  genderWoman: 'Mujer',
  genderYours: 'Juegas como',
  mixedFree: (m, f) => `Libres: H ${m} · M ${f}`,
  freeSpotM: 'Plaza libre (hombre)',
  freeSpotF: 'Plaza libre (mujer)',
  pairsTitle: 'Parejas',
  pairsHint: 'Elige compañera para cada jugador. El torneo no puede empezar hasta formar todas las parejas.',
  pairsEmpty: 'El organizador formará las parejas antes de empezar.',
  pairNone: '— sin pareja —',
  pairsSaved: (done, total) => `Parejas formadas: ${done} de ${total}`,
  kindHintPairs: 'La app forma parejas equilibradas por nivel, todas juegan contra todas',
  playersCount: 'Jugadores',
  matchTo: 'Partido a',
  pointsUnit: 'puntos',
  gamesUnit: 'juegos',
  gameTypeLabel: 'Tipo de partido',
  ratedGame: 'Con ranking',
  friendlyGame: 'Amistoso',
  ratedGameHint: 'El resultado cambia el nivel de los cuatro jugadores.',
  friendlyGameHint: 'Sin ranking: puedes anotar el resultado para el historial, el nivel no cambia.',
  friendlyBadge: '🤝 Amistoso',
  friendlyNote: '🤝 Partido amistoso — el nivel no cambia.',
  ratedToggle: 'Cuenta para el nivel',
  createTournament: 'Crear torneo',
  tournamentBadge: (kind) => (kind === 'americano' ? '🏆 Americano' : kind === 'mexicano' ? '🏆 Mexicano' : kind === 'king' ? '👑 Rey de la pista' : '🏆 Torneo por parejas'),
  tournamentTitle: 'Torneo',
  startTournament: 'Empezar torneo',
  startConfirm: '¿Empezar el torneo? Se cierra la inscripción, la app crea el cuadro y avisa a cada uno de su primera pista.',
  resetTournament: 'Rehacer cuadro',
  resetConfirm: '¿Borrar el cuadro y reabrir la inscripción? Solo antes de meter algún resultado.',
  finishTournament: 'Terminar torneo',
  finishConfirm: (missing) =>
    (missing ? `${missing} partido(s) sin resultado no contarán. ` : '') +
    '¿Terminar? Puestos y niveles quedan fijos, todos reciben los resultados.',
  roundN: (n) => `Ronda ${n}`,
  courtN: (n) => `Pista ${n}`,
  teamN: (n) => `Pareja ${n}`,
  standings: 'Clasificación',
  colPoints: 'Pts',
  colWins: 'G',
  colDiff: '±',
  saveScore: 'Guardar',
  clearScore: 'Borrar',
  progress: (done, total) => `${done} de ${total} jugados`,
  statusRunning: 'En juego',
  statusFinished: 'Terminado',
  registrationOpen: 'Inscripción abierta',
  paidMark: 'pagado',
  notPaidMark: 'no pagado',
  forecastHint: 'El cambio de nivel es una previsión; se fija al terminar el torneo.',
  yourMatch: 'tú',
  tapToScore: 'Toca un partido para meter el resultado',
  scoreModeLabel: 'Cómo se puntúa',
  scoreGames: 'Juegos',
  scorePoints: 'Puntos, como americano',
  scoreHintGames: 'Partido a N juegos.',
  scoreHintPoints: 'Partido de N puntos, cada punto cuenta.',
  rankHintGames: 'Clasificación: victorias → diferencia de juegos → juegos ganados.',
  rankHintPoints: 'Clasificación: suma de puntos → victorias → diferencia.',
  customValue: 'Otro',
  autoValue: 'Auto',
  courtsLabel: 'Pistas',
  roundsLabel: 'Rondas',
  roundsHint: 'Auto — todos juegan con todos. Las rondas se ajustan para que todos jueguen lo mismo.',
  restHint: (n) => `Cada ronda descansan ${n}, por turnos: todos juegan los mismos partidos.`,
  roundsUnlimited: 'Sin límite',
  editTournament: '✏️ Editar torneo',
  orgLockedTitle: '🔒 Los torneos los organizan organizadores',
  orgLockedText: 'Los torneos Americano, Mexicano y por parejas los crean jugadores aprobados por el administrador y los entrenadores. Envía una solicitud: la respuesta llega por Telegram.',
  orgRequest: 'Solicitar acceso',
  orgPending: 'Solicitud enviada: esperando al administrador.',
  orgRejected: 'Por ahora no se ha aprobado. Puedes volver a intentarlo en 24 horas.',
  orgSent: 'Solicitud enviada',
  orgBadge: '🏆 organizador',
  orgBadgePending: '🏆 solicitud de torneos',
  orgApprove: 'Permitir torneos',
  orgReject: 'Rechazar',
  orgRevoke: 'Quitar acceso a torneos',
  orgSection: 'Torneos',
  editSectionWhen: 'Cuándo y dónde',
  editSectionMoney: 'Inscripción y descripción',
  editSectionFormat: 'Formato',
  priceEuro: 'Inscripción por persona, €',
  priceNone: 'gratis',
  lockedAfterStart: 'No se cambia tras el inicio',
  editNotifyHint: 'Los jugadores reciben un aviso si cambian la hora, el club, la inscripción o los puntos por partido.',
  editSaved: 'Cambios guardados',
  correctHint: 'Toca un partido para corregir el resultado: la clasificación y los niveles se recalculan.',
  correctConfirm: '¿Corregir un resultado del torneo terminado? Se recalculan puestos y niveles; quienes cambien recibirán un aviso.',
  mexicanoRoundsHint: 'Auto — 6 rondas. «Sin límite» — se juega hasta que el organizador termine. Las rondas se crean una a una según la clasificación.',
  planUnlimited: (players, courts) => `${players} jugadores · ${courts} pista(s) · rondas sin límite`,
  roundOf: (n, total) => (total ? `Ronda ${n} de ${total}` : `Ronda ${n}`),
  nextRound: (n) => `Crear ronda ${n}`,
  nextRoundHint: 'Las parejas salen de la clasificación: en cada grupo de cuatro, 1+4 contra 2+3. Los jugadores reciben un mensaje con pista y pareja.',
  undoRound: (n) => `Rehacer ronda ${n}`,
  undoRoundConfirm: '¿Quitar esta ronda? Las parejas se rehacen según la clasificación actual — por ejemplo, tras corregir un resultado.',
  planLine: (players, rounds, courts, per) =>
    `${players} jugadores · ${rounds} rondas · ${courts} pista(s) · ${per} partidos cada uno`,
  tSettings: 'Ajustes del torneo',
  tSettingsLocked: 'El torneo está en juego: solo cambian los puntos por partido.',
  tSettingsLockedMex: 'El torneo está en juego: cambian los puntos por partido y el número de rondas.',
  placesLabel: 'Plazas',
  tabScore: 'Marcador',
  tabStats: 'Estadísticas',
  statsLive: 'Ahora',
  statsFinal: 'Final',
  roundShort: (n) => `R${n}`,
  afterRound: (n) => `Tras la ronda ${n}`,
  roundNotDone: 'ronda en juego',
  colPlayer: 'Jugador',
  colPair: 'Pareja',
  colWDL: 'G-E-P',
  colDelta: 'Δ',
  restingNow: (names) => `Descansan: ${names}`,
  youRest: 'En esta ronda descansas',
  liveHint: 'Se actualiza en tiempo real',
  podiumTitle: 'Ganadores',
  resultsTitle: 'Resultados del torneo',
  resultsHintBot: 'El bot te enviará una imagen y un PDF: reenvíalos al chat del torneo.',
  resultsHintFiles: 'Abre la imagen o el PDF y compártelos en cualquier chat.',
  resultsToTelegram: 'Enviar a Telegram',
  resultsSent: 'Hecho: el bot te enviará la imagen y el PDF en unos segundos. Reenvíalos al chat del torneo.',
  resultsImage: 'Imagen',
  resultsPdf: 'PDF',
  myResultTitle: 'Tu resultado',
  myPlace: (place, of) => `Puesto ${place} de ${of}`,
  myLine: (w, d, l, pf, pa, unit) => `${w + d + l} partidos · G-E-P ${w}-${d}-${l} · ${unit} ${pf}:${pa}`,
  myLevel: 'Nivel',
  totalsLine: (matches, pts, unit) => `Partidos jugados: ${matches} · total de ${unit}: ${pts}`,
  bothScores: 'Introduce el resultado de ambas parejas',
  whyPairAvg: (team, opp) => `Media del torneo: tu pareja ${team}, rivales ${opp}.`,
  whyExpectedPoints: (e, a) => `Se esperaba ${e}% de puntos, ganados ${a}%.`,
  placeOf: (place, of) => `Puesto ${place} de ${of}`,
  matchesWon: (wins, total) => `${wins} de ${total} ganados`,
  onbLevelTitle: '¿Cuál es tu nivel?',
  onbLevelSub: 'La misma escala que Playtomic: de 0 a 7. Tus primeros 10 partidos lo ajustarán.',
  onbPlaytomic: 'Conozco mi nivel de Playtomic',
  onbPlaytomicHint: 'El número junto a tu nombre en tu perfil de Playtomic, por ejemplo 2.84.',
  onbPlaytomicPlaceholder: 'Por ejemplo, 2.84',
  onbManual: 'Poner mi nivel a mano',
  onbManualHint: 'Elige el número que describa tu juego con más honestidad.',
  onbSurvey: 'No sé mi nivel',
  onbSurveyHint: 'Responde tres preguntas y lo estimamos.',
  onbLevelError: 'Introduce un nivel de 0 a 7',
  levelBand: (level) =>
    level < 1.5
      ? 'Empiezo: aprendo a darle a la bola'
      : level < 2.5
        ? 'Mantengo la bola en juego; las paredes aún me cuestan'
        : level < 3.5
          ? 'Peloteo, uso las paredes y subo a la red'
          : level < 4.5
            ? 'Sólido en la red, con bandeja y víbora'
            : level < 5.5
              ? 'Juego torneos, mantengo el ritmo, remato'
              : 'Nivel alto de torneo, entrenador',
  adminPlayers: 'Jugadores y niveles',
  adminHint: 'Toca un jugador para cambiar su nivel o el permiso de torneos (🏆 — solicitud o permiso). El jugador recibe un mensaje del bot.',
  adminSearch: 'Buscar por nombre o usuario',
  adminNoLevel: 'sin nivel',
  adminSource: (source) =>
    source === 'playtomic'
      ? 'Playtomic'
      : source === 'manual'
        ? 'manual'
        : source === 'survey'
          ? 'encuesta'
          : source === 'admin'
            ? 'admin'
            : '—',
  adminMatches: (n) => `partidos puntuados: ${n}`,
  adminNewLevel: 'Nuevo nivel',
  adminReset: 'Reiniciar calibración (los primeros 10 partidos vuelven a mover más el nivel)',
  adminSaved: 'Nivel guardado',
  adminEmpty: 'Sin resultados',
  onbTitle: 'Unas preguntas para ajustar tu nivel',
  onbMonths: 'Meses jugando',
  onbFrequency: 'Partidas al mes',
  onbBackground: 'Jugabas tenis, squash o bádminton',
  onbSelf: '¿Conoces tu nivel de Playtomic?',
  onbSide: 'Lado preferido',
  left: 'Izquierda',
  right: 'Derecha',
  both: 'Cualquiera',
  save: 'Guardar',
  yourLevel: 'Tu nivel',
  gamesPlayed: 'Partidas jugadas',
  reliability: 'Fiabilidad',
  loading: 'Cargando…',
  back: 'Atrás',
  levelWarning: 'El nivel no coincide con el tuyo — hace falta el visto bueno del capitán',
  roster: 'Jugadores',
  waitlistTitle: 'Lista de espera',
  captain: 'capitán',
  freeSpot: 'Plaza libre',
  route: 'Cómo llegar',
  clubBooking: 'Reserva del club',
  whatsapp: 'WhatsApp del club',
  allDays: 'Todos',
  today: 'Hoy',
  tomorrow: 'Mañana',
  noGamesOnDay: 'No hay partidas ese día. Crea una y se apuntarán.',
  chat: 'Chat',
  chatGame: 'Chat del partido',
  chatTournament: 'Chat del torneo',
  chatHint: 'Solo jugadores y reserva: dónde quedamos, quién llega tarde, quién trae bolas.',
  chatOpen: 'Abrir',
  chatNew: (n) => `${n} ${n === 1 ? 'nuevo' : 'nuevos'}`,
  chatEmpty: 'Aún no hay mensajes. Di dónde quedamos o quién trae las bolas.',
  chatPlaceholder: 'Mensaje',
  chatSend: 'Enviar',
  chatEarlier: 'Ver mensajes anteriores',
  chatPin: 'Fijar',
  chatUnpin: 'Quitar',
  chatDelete: 'Borrar',
  chatDeleteConfirm: '¿Borrar el mensaje?',
  chatPinned: 'Aviso del capitán',
  chatPinHint: 'Toca tu mensaje para fijarlo como aviso para todos.',
  yesterday: 'Ayer',
  invite: 'Invitar jugadores',
  inviteTitle: 'A quién invitar',
  inviteSearch: 'Buscar por nombre',
  inviteHint:
    'El jugador recibe un mensaje del bot y ve la invitación en la app. No se reserva plaza: entra el primero que acepte.',
  inviteHintFull: 'Partido completo — los invitados irán a la reserva.',
  inviteBtn: 'Invitar',
  invitedMark: 'Invitado',
  declinedMark: 'No puede',
  playedTogether: 'habéis jugado juntos',
  levelOff: 'nivel fuera del rango',
  noCandidates: 'No hay resultados. Envía un enlace personal aquí abajo.',
  notInApp: '¿No está en la app?',
  notInAppHint:
    'Envía un enlace personal: responde 4 preguntas y entra directamente en este partido, y te avisamos cuando se apunte.',
  viaTelegram: 'Telegram',
  viaWhatsApp: 'WhatsApp',
  inviteLinkText: (when, club, tournament) =>
    `Te invito a ${tournament ? 'un torneo de pádel' : 'jugar al pádel'}: ${when}, ${club}. Apúntate aquí`,
  invitesYou: (who, kind) =>
    `${who} te invita a ${kind === 'game' ? 'un partido' : kind === 'training' ? 'un entrenamiento en grupo' : kind === 'americano' ? 'un torneo Americano' : kind === 'mexicano' ? 'un torneo Mexicano' : kind === 'king' ? 'un torneo Rey de la pista' : 'un torneo por parejas'}`,
  inviteGo: 'Voy',
  inviteGoWaitlist: 'Ir a la reserva',
  inviteNo: 'No puedo',
  inviteMore: 'Detalles',
  inviteLater: 'Luego',
  inviteCount: (i, n) => `${i} de ${n}`,
  invitedWaiting: (who) => `invitado por ${who} · esperando`,
  doneClose: 'Listo',
  share: 'Compartir en chat',
  markBooked: 'Marcar pista reservada',
  markNotBooked: 'Quitar reserva',
  cancelGame: 'Cancelar partida',
  cancelGameConfirm: '¿Cancelar la partida para todos? Se avisará a los jugadores.',
  leaveConfirm: '¿Salir de la partida? A menos de 12 horas baja tu fiabilidad.',
  gameCancelled: 'Partida cancelada',
  notFound: 'Partida no encontrada o ya terminada',
  lowReliability: 'cancela a menudo',
  shareText: (when, club, lo, hi, free) =>
    `Pádel ${when}, ${club}. Nivel ${lo}–${hi}. ` +
    (free > 0 ? `Quedan ${free} plazas.` : 'Completo, lista de espera abierta.'),
  result: 'Resultado',
  enterScore: 'Anotar resultado',
  scoreHint: '¿Cambiasteis de pareja? Anota cada partido por separado. Un rival lo confirma.',
  partner: 'Tu pareja',
  opponents: 'Rivales',
  us: 'Nosotros',
  them: 'Ellos',
  setN: (n) => `Set ${n}`,
  superTiebreak: 'Súper tie-break',
  submitScore: 'Enviar para confirmar',
  confirmScore: 'Confirmar',
  disputeScore: 'Disputar',
  withdrawScore: 'Retirar',
  disputeConfirm: '¿Disputar el resultado? El nivel no cambia; habrá que anotarlo de nuevo.',
  pendingScore: (h) => `Pendiente · ${h} h`,
  confirmedScore: 'Confirmado',
  disputedScore: 'Disputado',
  win: 'Victoria',
  loss: 'Derrota',
  draw: 'Empate',
  vs: 'contra',
  withPartner: 'con',
  calibration: (n, total) => `Calibración: ${n} de ${total} partidos`,
  calibrated: 'Nivel calibrado',
  ratingHistory: 'Historial de nivel',
  statMatches: 'Partidos',
  statWins: 'Victorias',
  stat30d: 'Últimos 30 días',
  statGames: 'Juegos',
  levelChart: 'Nivel por partido',
  chartEmpty: 'El gráfico aparecerá tras tu primer partido confirmado.',
  chartStart: 'inicio',
  bestLevel: (v) => `mejor ${v}`,
  matchHistory: 'Historial de partidos',
  noMatches: 'Aquí aparecerán tus partidos con resultado, confirmados y pendientes.',
  statusPending: 'pendiente de confirmar',
  statusDisputed: 'impugnado',
  changeTime: 'Cambiar hora o club',
  changeGameConfirm: (when, club) => `¿Mover el partido a ${when}, ${club}? Los jugadores recibirán un aviso.`,
  courtSpotsTitle: 'En la pista',
  pairN: (n) => `Pareja ${n}`,
  spotLeft: 'izquierda',
  spotRight: 'derecha',
  spotEmpty: 'libre',
  spotTake: 'Aquí',
  spotHint: 'Toca un sitio libre para elegir pareja y lado. Tócate a ti para dejar el sitio.',
  spotHintCaptain: 'El capitán puede mover a cualquiera: toca a un jugador y luego un sitio; se intercambian.',
  spotUnplaced: 'Sin sitio aún',
  spotMoving: (name) => `¿Dónde juega ${name}?`,
  changeTimeHint: 'Todos reciben un aviso del cambio y pueden salir sin penalización durante 24 horas.',
  changeTimeConfirm: (when) => `¿Mover el partido a ${when}? Se avisará a los jugadores.`,
  timeChanged: 'Hora cambiada, jugadores avisados',
  shareWhatsApp: 'WhatsApp',
  inviteFriendsTitle: 'Invita a tus amigos',
  inviteFriendsHint: 'Cuantos más jugadores de tu nivel, antes se completa el partido. El bot te avisará cuando tu amigo se una.',
  inviteFriendsText: 'Juego al pádel con Por4: partidos y torneos por nivel en la Costa Blanca. Únete:',
  invitedCount: (n: number) => `Se han unido con tu enlace: ${n}`,
  copyLink: 'Copiar enlace',
  linkCopied: 'Enlace copiado',
  linkCopyFailed: 'No se pudo copiar — selecciona el enlace a mano',
  shareOutsideHint: 'Para WhatsApp y otras apps usa este enlace: abre el partido aunque Telegram muestre el chat del bot.',
  disputeUntil: (hours) => `Se puede disputar ${hours} h más`,
  disputeConfirmed: '¿Disputar un resultado confirmado? Se revertirá el cambio de nivel de los cuatro y habrá que anotarlo de nuevo.',
  gameHistory: 'Historial de partidos',
  noGameHistory: 'Aquí verás tus partidos pasados: dónde, con quién y el resultado.',
  noScoreYet: 'Sin resultado',
  playedWith: 'Jugadores',
  loginTitle: 'Pádel por nivel en la Costa Blanca',
  loginSub: 'Monta tu partido en un minuto. Entra para ver partidos de tu nivel.',
  loginTelegram: 'Entrar con Telegram',
  loginTelegramHint: 'Si ya usabas Por4 en Telegram, aquí tendrás tu nivel y tu historial.',
  loginApple: 'Entrar con Apple',
  loginWaiting: 'Se abrirá Telegram. Pulsa «Sí, entrar» y vuelve a la app.',
  loginOpenAgain: 'Abrir Telegram otra vez',
  loginCancel: 'Cancelar',
  loginExpired: 'Se acabó el tiempo. Inténtalo de nuevo.',
  loginFailed: 'No se pudo entrar. Inténtalo de nuevo.',
  accountTitle: 'Cuenta',
  linkTelegram: 'Vincular Telegram',
  linkTelegramHint: 'Los avisos de partidos y las invitaciones los envía el bot de Telegram. Vincúlalo para no perderte nada.',
  linkTaken: 'Este Telegram ya está vinculado a otro perfil de Por4. Cierra sesión y entra con Telegram para abrirlo.',
  linkDone: 'Telegram vinculado',
  logout: 'Cerrar sesión',
  logoutConfirm: '¿Cerrar sesión en este dispositivo?',
  deleteAccount: 'Eliminar cuenta',
  deleteAccountConfirm: '¿Eliminar tu cuenta? Se borrarán tu perfil y tu nivel y se cancelarán tus próximos partidos. No se puede deshacer.',
  deleteAccountConfirm2: '¿Seguro? La cuenta no se podrá recuperar.',
  openGame: 'Abrir partida',
  noHistory: 'Tu nivel empezará a moverse tras el primer partido confirmado.',
  explain: (e, a) => `esperado ${e}% de juegos, ganados ${a}%`,
  wonSet: 'Ganado',
  lostSet: 'Perdido',
  otherScore: 'Otro resultado',
  quickScore: 'Botones',
  scoreLabel: 'Resultado',
  thirdSet: 'Tercer set',
  fullSet: 'Set completo',
  tbWinner: 'Quién ganó el super tie-break',
  tbPoints: 'Puntos, si los recuerdas',
  tbShort: 'TB',
  pickSet: 'Marca el resultado del set',
  summary: (res, sa, sb, ga, gb) => `${res} ${sa}:${sb} en sets · ${ga}:${gb} en juegos`,
  previewTitle: 'Si el rival lo confirma',
  projected: 'previsión',
  youLabel: 'tú',
  whyPair: (team, opp) => `Tu pareja ${team}, rivales ${opp}.`,
  whyPairOf: (team, opp) => `Pareja ${team} contra ${opp}.`,
  whyExpected: (e, a) => `Se esperaba ${e}% de juegos, ganados ${a}%.`,
  reason: {
    better: 'Mejor de lo esperado: el nivel sube.',
    worse: 'Peor de lo esperado: el nivel baja.',
    as_expected: 'Resultado acorde a lo esperado: cambio mínimo.',
    win_guarded: 'Menos juegos de lo esperado, pero una victoria nunca baja el nivel.',
    loss_guarded: 'Más juegos de lo esperado, pero una derrota nunca sube el nivel.',
  },
  capped: 'Límite aplicado: máximo 0.35 por partido.',
  calibrating: 'Calibrando: los 10 primeros partidos mueven más el nivel.',
  ratingRule:
    'El nivel cambia según el resultado y la fuerza de los rivales. Ganar a más débiles da poco; perder contra ellos cuesta mucho.',
  // --- Solicitudes de pista (v0.35) ---
  bookCourt: 'Reservar pista',
  bookTitle: (club) => `Pista · ${club}`,
  bookDay: 'Día',
  bookDuration: 'Duración',
  bookCourtPick: 'Pista',
  bookAnyCourt: 'Cualquiera',
  bookTime: 'Hora',
  bookToday: 'hoy',
  bookTomorrow: 'mañana',
  bookHours: (m) => (m % 60 ? `${Math.floor(m / 60)},5 h` : `${m / 60} h`),
  bookNoTimes: 'No hay horas libres este día: elige otro.',
  bookFor: (when) => `Pista para el partido · ${when}`,
  bookAutoCourt: 'primera pista libre',
  bookNote: 'Comentario para el club',
  bookNotePh: 'Opcional, p. ej. «necesitamos bolas»',
  bookRules: (reply, cancel) =>
    `El club confirma la solicitud, normalmente en ${reply} h; la respuesta llega por Telegram. Pago por transferencia al club tras la confirmación. Cancelación gratuita hasta ${cancel} h antes.`,
  bookSend: 'Enviar solicitud',
  bookSent: 'Solicitud enviada',
  bookSentHint: (when) => `El club responderá antes de ${when}. Mientras tanto, la hora queda reservada para ti.`,
  bookMine: 'Mis reservas',
  bookDone: 'Listo',
  bookFrom: (price) => `desde ${price}`,
  bookStatus: {
    requested: 'Esperando al club',
    confirmed: 'Confirmada',
    declined: 'El club la rechazó',
    cancelled: 'Cancelada',
    expired: 'El club no respondió',
  },
  bookWaitUntil: (when) => `El club responderá antes de ${when}`,
  bookPay: 'Pago por transferencia',
  bookIban: 'IBAN',
  bookHolder: 'Titular',
  bookConcept: 'Concepto',
  bookAmount: 'Importe',
  bookCopied: 'Copiado',
  bookFreeUntil: (when) => `Cancelación gratuita hasta ${when}`,
  bookLateNow: 'Si cancelas ahora, será tardía',
  bookCancel: 'Cancelar',
  bookWithdraw: 'Retirar solicitud',
  bookCancelAsk: '¿Cancelar la reserva? Avisaremos al club.',
  bookCancelLateAsk: (h) =>
    `Faltan menos de ${h} h: es una cancelación tardía. El club lo verá y decidirá sobre el pago, y tu fiabilidad baja. ¿Cancelar?`,
  bookWithdrawAsk: '¿Retirar la solicitud?',
  bookEmpty: 'Aún no tienes reservas',
  bookPast: 'Pasadas y canceladas',
  bookRoute: 'Cómo llegar',
  bookAgain: 'Elegir otra hora',
  bookLate: 'cancelación tardía',
  bookCancelledBy: { player: 'la cancelaste', club: 'la canceló el club', calendar: 'la canceló el club' },
  bookNoShow: 'no se presentó',
  bookHome: 'Reserva de pista',
  bookHomeHint: (courts, price) => `${courts} pista${courts === 1 ? '' : 's'} · solicitud online${price ? ` · ${price}` : ''}`,
  bookDemo: 'demo',
  gameBookCourt: (club) => `🎾 Pedir pista en ${club}`,
  gameBookPending: 'Solicitud de pista enviada: esperando al club',
  profileBookings: (n) => (n ? `🎾 Mis reservas · ${n}` : '🎾 Mis reservas'),
  deskOpen: (club, n) => `📋 Panel del club · ${club}${n ? ` · ${n} nuevas` : ''}`,
  deskTitle: (club) => `Panel · ${club}`,
  deskNew: (n) => `Solicitudes nuevas · ${n}`,
  deskSchedule: 'Agenda',
  deskPast: 'Pasadas, rechazadas y canceladas',
  deskNothingNew: 'No hay solicitudes nuevas',
  deskConfirm: 'Confirmar',
  deskDecline: 'Ocupado',
  deskCancel: 'Cancelar reserva',
  deskCancelAsk: '¿Cancelar esta reserva confirmada? Avisaremos al jugador.',
  deskNoShow: 'No vino',
  deskNoShowUndo: 'Quitar «no vino»',
  deskReply: (when) => `responder antes de ${when}`,
  deskLevel: (lvl, rel) => `nivel ${lvl} · fiabilidad ${rel}%`,
  deskSettings: 'Ajustes del club',
  deskHours: (open, close, step) => `Horario ${open}–${close}, tramos de ${step} min`,
  deskCancelRule: (h) => `Cancelación gratuita hasta ${h} h antes`,
  deskReplyRule: (h) => `Las solicitudes esperan respuesta hasta ${h} h (el plazo nunca vence de noche)`,
  deskCalendarOn: 'Google Calendar conectado',
  deskCalendarSynced: (when) => `disponibilidad actualizada ${when}`,
  deskCalendarOff: 'Google Calendar no conectado',
  deskCalendarHow: (email) =>
    `Para conectar: Google Calendar → configuración del calendario → «Compartir con determinadas personas» → añade ${email} con «Hacer cambios en eventos» y envíanos el ID del calendario.`,
  deskCalendarNoSa: 'La conexión del calendario la configura Por4: escríbenos.',
  deskCalendarError: 'El evento no llegó al calendario',
  deskEmail: (email) => `Copia de las solicitudes a ${email}`,
  deskLink: 'Enlace para jugadores',
  deskLinkHint: 'Envíalo a los vecinos por WhatsApp o ponlo en tu web: abre la reserva de tu club.',
  deskHidden: 'Demo: la reserva no aparece en la lista, solo por enlace',
  deskEmpty: 'Aún no hay reservas',
  deskCopyLink: 'Copiar enlace',
  deskCancelledBy: { player: 'canceló el jugador', club: 'canceló el club', calendar: 'borrada en el calendario' },
  // --- Rey de la pista (v0.36) ---
  kindKing: '👑 Rey de la pista',
  colWL: 'G-P',
  kindHintKing:
    'Parejas fijas en una escalera de pistas: la pista 1 es la del rey. Los ganadores suben una pista y los perdedores bajan. Rondas por tiempo.',
  rankHintKing: 'Puestos según la escalera: 1.º — el ganador de la pista 1 en la última ronda, 2.º — el perdedor de esa pista, y así.',
  roundMinutesLabel: 'Minutos por ronda',
  roundMinutesShort: (n) => `rondas de ${n} min`,
  kingRoundHint: 'El organizador pone en marcha el temporizador y todos ven la cuenta atrás. Se cuentan juegos; un empate lo decide el punto de oro.',
  kingLadderHint: 'Orden inicial por nivel de pareja: las más fuertes en la pista 1. Podéis formar las parejas antes de empezar.',
  goldenAsk: 'Empate: ¿quién ganó el punto de oro?',
  kingRestHint: 'Número impar de parejas: en cada ronda descansa una, la que pierde en la pista de abajo',
  kingPairsHint: 'Puedes formar parejas tú. Al empezar, la app junta al resto por nivel (fuerte con más flojo).',
  kingPairsRest: 'Al empezar, la app junta al resto por nivel.',
  kingPairsAuto: (n) => `Sin pareja: ${n}; se emparejarán por nivel al empezar`,
  timerRunning: 'en marcha',
  timerOver: '¡Tiempo!',
  timerWaiting: 'Esperando a que el organizador empiece la ronda',
  timerRestart: 'Reiniciar',
  timerStart: (round) => `Empezar ronda ${round}`,
  timerStop: 'Parar',
  crownsHint: 'Rondas en la pista 1',
  kingMovesHint: '👑 — sigue en la pista 1 · ▲ — sube · ▼ — baja · ☕ — descansa · = — se queda',
  kingNextHint: 'Los ganadores suben una pista y los perdedores bajan. El temporizador de la nueva ronda, con «Empezar ronda».',
  weekdays: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
  locale: 'es-ES',
}

const DICT: Record<Lang, Dict> = { ru, en, es }

/** Любой код языка → один из трёх наших. Русский — для русского и близких
 *  к нему (украинский, белорусский, казахский), испанский — для испанского,
 *  каталанского и галисийского, остальным — английский. Та же логика у бота.
 *  Важно: в базе у игрока может лежать код, которого у нас нет (например
 *  "uk" или "de" из Telegram) — без этой функции t() вернул бы undefined
 *  и приложение показало бы пустой экран. */
export function normalizeLang(code: string | null | undefined): Lang {
  const short = (code ?? '').slice(0, 2).toLowerCase()
  if (['ru', 'uk', 'be', 'kk'].includes(short)) return 'ru'
  if (['es', 'ca', 'gl'].includes(short)) return 'es'
  return short ? 'en' : 'es'
}

// Испанский — основной: новый игрок начинает на нём, что бы ни стояло в
// телефоне (решение владельца 09.10.2026). Дальше — язык из профиля.
let current: Lang = 'es'

export function setLang(lang: string): void {
  current = normalizeLang(lang)
}

export function currentLang(): Lang {
  return current
}

export function t(): Dict {
  return DICT[current]
}

/** «вт 22.09 в 20:00» в локали пользователя */
export function formatWhen(iso: string): string {
  const d = new Date(iso)
  const day = t().weekdays[d.getDay()]
  const date = d.toLocaleDateString(t().locale, { day: '2-digit', month: '2-digit' })
  const time = d.toLocaleTimeString(t().locale, { hour: '2-digit', minute: '2-digit' })
  return `${day} ${date}, ${time}`
}
